<div class="d-flex flex-row align-items-center gap-3">
    <strong class="d-none d-md-block">Setting</strong>
    <ul class="nav nav-tabs overflow-auto w-100 flex-nowrap" id="myTab" role="tablist" style="overflow-y: hidden;">
        <li class="nav-item" role="presentation">
            <button class="nav-link text-nowrap" [class.active]="selectedTab === 'general'" id="general-tab" (click)="selectTab('general')"
                type="button" role="tab" aria-controls="general" aria-selected="true">General</button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link text-nowrap" [class.active]="selectedTab === 'tracking'" id="tracking-tab" (click)="selectTab('tracking')"
                type="button" role="tab" aria-controls="tracking" aria-selected="false">Frontend Pixel</button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link text-nowrap" [class.active]="selectedTab === 'apk-download'" id="apk-download-tab" (click)="selectTab('apk-download')"
                type="button" role="tab" aria-controls="apk-download" aria-selected="false">APK Download</button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link text-nowrap" [class.active]="selectedTab === 'communication'" id="communication-tab" (click)="selectTab('communication')"
                type="button" role="tab" aria-controls="communication"
                aria-selected="true">Communication</button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link text-nowrap" [class.active]="selectedTab === 'registration'" id="registration-tab" (click)="selectTab('registration')"
                type="button" role="tab" aria-controls="registration"
                aria-selected="false">Registration</button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link text-nowrap" [class.active]="selectedTab === 'credit'" id="credit-tab" (click)="selectTab('credit')"
                type="button" role="tab" aria-controls="credit" aria-selected="false">Credit</button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link text-nowrap" [class.active]="selectedTab === 'design'" id="design-tab" (click)="selectTab('design')"
                type="button" role="tab" aria-controls="design" aria-selected="false">Design</button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link text-nowrap" [class.active]="selectedTab === 'live-transaction'" id="live-transaction-tab" (click)="selectTab('live-transaction')"
                type="button" role="tab" aria-controls="live-transaction" aria-selected="false">Live Transaction</button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link text-nowrap" [class.active]="selectedTab === 'promotion'" id="promotion-tab" (click)="selectTab('promotion')"
                type="button" role="tab" aria-controls="promotion" aria-selected="false">Promotion</button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link text-nowrap" [class.active]="selectedTab === 'fortune-fall'" id="fortune-fall-tab" (click)="selectTab('fortune-fall')"
                type="button" role="tab" aria-controls="fortune-fall" aria-selected="false">Fortune Fall</button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link text-nowrap" [class.active]="selectedTab === 'footer'" id="footer-tab" (click)="selectTab('footer')"
                type="button" role="tab" aria-controls="footer" aria-selected="false">Footer</button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link text-nowrap" [class.active]="selectedTab === 'withdrawdeposit'" id="withdrawdeposit-tab" (click)="selectTab('withdrawdeposit')"
                type="button" role="tab" aria-controls="withdrawdeposit"
                aria-selected="false">Withdraw Deposit</button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link text-nowrap" [class.active]="selectedTab === 'agent'" id="agent-tab" (click)="selectTab('agent')"
                type="button" role="tab" aria-controls="agent" aria-selected="false">Agent</button>
        </li>
    </ul>
</div>
<div class="row">
    <div class="col-12 col-md-5">
        <form #f="ngForm" (ngSubmit)="submit()" novalidate>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade" [class.show]="selectedTab === 'general'" [class.active]="selectedTab === 'general'" id="general" role="tabpanel" aria-labelledby="general-tab">
                    <h3 class="mb-0 mt-3 fw-bolder">General Info</h3>
                    <p class="mb-3 hint">This is the general information of the website. You can change the brand name,
                        logo, website title, and enable SEO.</p>
                    <div class="mb-3">
                        <label for="brand_name" class="form-label fw-bolder">Brand Name</label>
                        <input type="text" class="form-control" id="brand_name" placeholder="Brand Name"
                            name="brand_name" #brand_name="ngModel" [(ngModel)]="data.brand_name" />
                        <p class="mb-0 hint">This is the name of the brand. It will be displayed in the website.</p>
                    </div>

                    <div class="mb-3">
                        <label for="logo" class="form-label fw-bolder">Logo</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'logo', true)"
                            (deleteEvent)="delete($event, 'logo')" #logoUploader></app-image-uploader>
                        <p class="mb-0 hint">This is the logo of the brand. It will be displayed in the website.</p>
                    </div>

                    <div class="mb-3">
                        <label for="favicon" class="form-label fw-bolder">Favicon</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'favicon', true)"
                            (deleteEvent)="delete($event, 'favicon')" [favicon]="true"
                            #faviconUploader></app-image-uploader>
                        <p class="mb-0 hint">This is the favicon of the brand. It will be displayed in the website.</p>
                    </div>

                    <div class="mb-3">
                        <label for="web_title" class="form-label fw-bolder">Website Title</label>
                        <input type="text" class="form-control" id="web_title" placeholder="Website Title"
                            name="web_title" #web_name="ngModel" [(ngModel)]="data.web_title" maxlength="99" />
                        <p class="mb-0 hint">This is the name of the website. It will be displayed in the browser tab
                            and the website title.</p>
                    </div>

                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'enabled_seo'" [title]="'Enabled SEO'"
                            [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, the user or search engine will be able to see the SEO
                            information in the website.</p>
                    </div>

                    <div class="mb-3">
                        <label for="meta_description" class="form-label fw-bolder">Meta Description</label>
                        <textarea class="form-control" id="meta_description" placeholder="Enter Meta Description"
                            name="meta_description" #meta_description="ngModel"
                            [(ngModel)]="data.meta_description"></textarea>
                        <p class="mb-0 hint">This is the meta description of the website. It will be displayed in the
                            browser meta description tag.</p>
                    </div>
                    <div class="mb-3">
                        <label for="meta_keywords" class="form-label fw-bolder">Meta Keywords</label>
                        <textarea class="form-control" id="meta_keywords" placeholder="Enter Meta Keywords"
                            name="meta_keywords" #meta_keywords="ngModel" [(ngModel)]="data.meta_keywords"></textarea>
                        <p class="mb-0 hint">This is the meta keywords of the website. It will be displayed in the
                            browser meta keywords tag.</p>
                    </div>
                    <hr />
                    <h3 class="mb-0 mt-3 fw-bolder">Clear Balance (Buang Baki)</h3>
                    <div class="mb-3">
                        <label for="clear_balance_limit" class="form-label fw-bolder">Clear Balance Limit</label>
                        <input type="number" class="form-control" id="clear_balance_limit" placeholder="5"
                            name="clear_balance_limit" [(ngModel)]="data.clear_balance_limit" step="0.1" min="0" />
                        <p class="mb-0 hint">Maximum wallet balance allowed to clear balance. Default is 5.</p>
                    </div>
                    <hr />
                    <h3 class="mb-0 mt-3 fw-bolder">Language</h3>
                    <div class="mb-3">
                        <label for="default_language" class="form-label fw-bolder">Default Language</label>
                        <select class="form-control" [(ngModel)]="data.default_language" name="default_language"
                            #default_language="ngModel">
                            <option value="en">English</option>
                            <option value="cn">Chinese</option>
                            <option value="my">Malay</option>
                        </select>
                        <p class="mb-0 hint">This is the default language of the website. It will be displayed in the
                            website.</p>
                    </div>
                    <h3 class="mb-3">Enable Language</h3>
                    <app-checbox class="mb-3" [setData]="data" [key]="'language_en'" [title]="'English'"
                        [value]="true"></app-checbox>
                    <div class="mb-3">
                        <label class="form-label fw-bolder">English Language Image (Optional)</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'language_en_image', true)"
                            (deleteEvent)="delete($event, 'language_en_image')" #languageEnImage></app-image-uploader>
                        <p class="mb-0 hint">Upload a flag or icon for English language button. Leave empty to show
                            text.</p>
                    </div>
                    <app-checbox class="mb-3" [setData]="data" [key]="'language_cn'" [title]="'Chinese'"
                        [value]="true"></app-checbox>
                    <div class="mb-3">
                        <label class="form-label fw-bolder">Chinese Language Image (Optional)</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'language_cn_image', true)"
                            (deleteEvent)="delete($event, 'language_cn_image')" #languageCnImage></app-image-uploader>
                        <p class="mb-0 hint">Upload a flag or icon for Chinese language button. Leave empty to show
                            text.</p>
                    </div>
                    <app-checbox class="mb-3" [setData]="data" [key]="'language_ms'" [title]="'Malay'"
                        [value]="true"></app-checbox>
                    <div class="mb-3">
                        <label class="form-label fw-bolder">Malay Language Image (Optional)</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'language_ms_image', true)"
                            (deleteEvent)="delete($event, 'language_ms_image')" #languageMsImage></app-image-uploader>
                        <p class="mb-0 hint">Upload a flag or icon for Malay language button. Leave empty to show text.
                        </p>
                    </div>
                    <div class="mb-3">
                        <p class="mb-0 hint">If you enable this, the user will be able to choose the language of the
                            website.</p>
                    </div>
                    <hr />
                    <h3 class="mb-0 mt-3 fw-bolder">HOT GAMES ANIMATION STYLE</h3>
                    <div class="mb-3">
                        <label for="hot_games_animation_style" class="form-label fw-bolder">Hot Games Animation
                            Style</label>
                        <select class="form-control" [(ngModel)]="data.hot_games_animation_style"
                            name="hot_games_animation_style" #hot_games_animation_style="ngModel">
                            <option value="animate-fade">Fade</option>
                            <option value="animate-float">Float</option>
                            <option value="animate-zoom">Zoom</option>
                        </select>
                        <p class="mb-0 hint">This is the animation style of the hot games. It will be displayed in the
                            website.</p>
                    </div>
                </div>

                <div class="tab-pane fade" [class.show]="selectedTab === 'tracking'" [class.active]="selectedTab === 'tracking'" id="tracking" role="tabpanel" aria-labelledby="tracking-tab">
                    <h3 class="mb-0 mt-3 fw-bolder">Frontend Pixel</h3>
                    <p class="mb-3 hint">Configure website tracking scripts for the player frontend.</p>

                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'enabled_facebook_pixel'" [title]="'Enable Facebook Pixel'"
                            [value]="true"></app-checbox>
                    </div>
                    <div class="mb-3">
                        <label for="facebook_pixel_id" class="form-label fw-bolder">Facebook Pixel ID</label>
                        <input type="text" class="form-control" id="facebook_pixel_id" placeholder="123456789012345"
                            name="facebook_pixel_id" [(ngModel)]="data.facebook_pixel_id" maxlength="30" pattern="[0-9]*" />
                        <p class="mb-0 hint">Enter only the numeric Pixel ID. The frontend will load the Meta Pixel script automatically.</p>
                        <p class="mb-0 text-danger small" *ngIf="data.facebook_pixel_id && !isNumericId(data.facebook_pixel_id)">
                            Current value is not a valid Meta Pixel ID. Use digits only.
                        </p>
                    </div>

                    <hr />

                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'enabled_google_tag_manager'" [title]="'Enable Google Tag Manager'"
                            [value]="true"></app-checbox>
                    </div>
                    <div class="mb-3">
                        <label for="google_tag_manager_id" class="form-label fw-bolder">Google Tag Manager ID</label>
                        <input type="text" class="form-control" id="google_tag_manager_id" placeholder="GTM-XXXXXXX"
                            name="google_tag_manager_id" [(ngModel)]="data.google_tag_manager_id" maxlength="30" />
                        <p class="mb-0 hint">Enter the GTM container ID, for example GTM-XXXXXXX.</p>
                    </div>
                </div>

                <div class="tab-pane fade" [class.show]="selectedTab === 'apk-download'" [class.active]="selectedTab === 'apk-download'" id="apk-download" role="tabpanel" aria-labelledby="apk-download-tab">
                    <h3 class="mb-0 mt-3 fw-bolder">Mobile App</h3>
                    <p class="mb-3 hint">Configure the Android APK download button and tenant app build settings.</p>
                    <div class="mb-3">
                        <label for="mobile_app_name" class="form-label fw-bolder">App Name</label>
                        <input type="text" class="form-control" id="mobile_app_name" placeholder="Leave empty to use company name"
                            name="mobile_app_name" [(ngModel)]="data.mobile_app_name" maxlength="50" />
                        <p class="mb-0 hint">Used for Android app label and iOS tenant config. If empty, the company or brand name is used.</p>
                    </div>
                    <div class="mb-3">
                        <label class="form-label fw-bolder">App Icon</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'mobile_app_icon', true)"
                            (deleteEvent)="delete($event, 'mobile_app_icon')" [loadImage]="data.mobile_app_icon"
                            #mobileAppIcon></app-image-uploader>
                        <p class="mb-0 hint">Used when regenerating the app. If empty, the default app icon is used.</p>
                    </div>
                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'enabled_frontend_apk_download'" [title]="'Show APK Download Button'"
                            [value]="true"></app-checbox>
                        <p class="mb-0 hint">If enabled, the player frontend will show a floating Android APK download button.</p>
                    </div>
                    <div class="mb-3">
                        <label class="form-label fw-bolder">APK Download Route</label>
                        <div class="input-group">
                            <input type="text" class="form-control" [value]="androidApkDownloadUrl" readonly />
                            <a class="btn btn-outline-primary"
                                [class.disabled]="!data.mobile_android_apk_s3_key"
                                [attr.aria-disabled]="!data.mobile_android_apk_s3_key ? true : null"
                                [attr.tabindex]="!data.mobile_android_apk_s3_key ? -1 : null"
                                [href]="androidApkDownloadUrl" download target="_blank" rel="noopener">
                                Download
                            </a>
                        </div>
                        <p class="mb-0 hint">This route is generated automatically for the selected tenant and downloads the APK from S3. The Download button is disabled until the APK has been built.</p>
                    </div>
                    <div class="mb-3">
                        <label for="frontend_apk_download_label" class="form-label fw-bolder">Button Label</label>
                        <input type="text" class="form-control" id="frontend_apk_download_label" placeholder="Download App"
                            name="frontend_apk_download_label" [(ngModel)]="data.frontend_apk_download_label" maxlength="30" />
                    </div>
                    <div class="mb-3" *ngIf="data.mobile_android_apk_built_at">
                        <label class="form-label fw-bolder">Last Android Build</label>
                        <input type="text" class="form-control" [value]="data.mobile_android_apk_built_at" readonly />
                    </div>
                    <ng-container *ngIf="mobilePlayerBuildAvailable">
                        <div class="d-flex flex-row flex-wrap gap-2 mb-3">
                            <button type="button" class="btn btn-primary" (click)="regenerateAndroidApk()" [disabled]="mobileBuildLoading">
                                {{ mobileBuildLoading ? 'Building...' : 'Regenerate Android APK' }}
                            </button>
                            <button type="button" class="btn btn-outline-secondary" (click)="prepareIosConfig()" [disabled]="mobileBuildLoading">
                                Prepare iOS Config
                            </button>
                        </div>
                        <p class="mb-3 hint">Build actions are only available on the dev environment, which has the mobile-player toolchain installed. Production hosts do not ship the toolchain — contact the dev team to rebuild.</p>
                        <div class="alert mb-3" [class.alert-success]="mobileBuildResult?.status" [class.alert-warning]="!mobileBuildResult?.status"
                            *ngIf="mobileBuildResult">
                            <div>{{ mobileBuildResult.message }}</div>
                            <div class="small mt-1" *ngIf="mobileBuildResult.download_url">Download: {{ mobileBuildResult.download_url }}</div>
                            <div class="small mt-1" *ngIf="mobileBuildResult.s3_key">S3: {{ mobileBuildResult.s3_key }}</div>
                        </div>
                    </ng-container>
                </div>

                <div class="tab-pane fade" [class.show]="selectedTab === 'communication'" [class.active]="selectedTab === 'communication'" id="communication" role="tabpanel" aria-labelledby="communication-tab">
                    <h3 class="mb-0 mt-3 fw-bolder">Chat & Social Media</h3>
                    <p class="mb-3 hint">This is the chat and social media information of the website. You can change
                        the whatsapp number, facebook link, whatsapp link, and telegram link.</p>
                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'disabled_platform_chat'"
                            [title]="'Disabled Platform Chat'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, the player not able to chat with the admin using the
                            platform chat system.</p>
                    </div>
                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'enabled_customer_chat_history'"
                            [title]="'Enabled Customer Chat History'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, the player will be able to see the chat history.</p>
                    </div>
                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'enabled_chat_note'" [title]="'Enabled Chat Note'"
                            [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, The note will append on top of the chat page.</p>
                    </div>
                    <div class="mb-3">
                        <label for="chat_note" class="form-label fw-bolder fw-bold">Chat Note</label>
                        <p>This is the note that will be shown to the user when they are in the chat page.</p>
                        <quill-editor [format]="'html'" [(ngModel)]="data.chat_note" [required]="true"
                            [styles]="{minHeight: '250px'}"
                            (onEditorCreated)="editorCreated($event, 'chat_note')"></quill-editor>
                    </div>
                    <hr />
                    <div class="mb-3">
                        <label for="whatsapp_no" class="form-label fw-bolder">Whatsapp Number</label>
                        <input type="text" class="form-control" id="whatsapp_no" placeholder="Whatsapp No"
                            name="whatsapp_no" #whatsapp_no="ngModel" [(ngModel)]="data.whatsapp_no" maxlength="15" />
                        <p class="mb-0 hint">This is the whatsapp number of the website. It will be displayed in the
                            website. Example: +60123456789</p>
                    </div>
                    <hr />
                    <div class="mb-3">
                        <label for="whatsapp_link" class="form-label fw-bolder">Whatsapp Link</label>
                        <input type="text" class="form-control" id="whatsapp_link" placeholder="Whatsapp Link"
                            name="whatsapp_link" #whatsapp_link="ngModel" [(ngModel)]="data.whatsapp_link"
                            maxlength="99" />
                        <p class="mb-0 hint">This is the whatsapp link of the website. It will be displayed in the
                            website. Example: https://wa.me/60123456789</p>
                    </div>
                    <div class="mb-3">
                        <label for="whatsapp_image" class="form-label fw-bolder">Whatsapp Image</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'whatsapp_image')"
                            [loadImage]="data.whatsapp_image" (deleteEvent)="delete($event, 'whatsapp_image')"
                            #whatsappImage></app-image-uploader>
                    </div>
                    <hr />
                    <div class="mb-3">
                        <label for="facebook_link" class="form-label fw-bolder">Facebook Link</label>
                        <input type="text" class="form-control" id="facebook_link" placeholder="Facebook Link"
                            name="facebook_link" #facebook_link="ngModel" [(ngModel)]="data.facebook_link"
                            maxlength="99" />
                        <p class="mb-0 hint">This is the facebook link of the website. It will be displayed in the
                            website. Example: https://www.facebook.com/your-page</p>
                    </div>
                    <div class="mb-3">
                        <label for="facebook_image" class="form-label fw-bolder">Facebook Image</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'facebook_image')"
                            [loadImage]="data.facebook_image" (deleteEvent)="delete($event, 'facebook_image')"
                            #facebookImage></app-image-uploader>
                    </div>
                    <hr />
                    <div class="mb-3">
                        <label for="telegram_link" class="form-label fw-bolder">Telegram Link</label>
                        <input type="text" class="form-control" id="telegram_link" placeholder="Telegram Link"
                            name="telegram_link" #telegram_link="ngModel" [(ngModel)]="data.telegram_link"
                            maxlength="99" />
                        <p class="mb-0 hint">This is the telegram link of the website. It will be displayed in the
                            website. Example: https://t.me/your-channel</p>
                    </div>
                    <div class="mb-3">
                        <label for="telegram_image" class="form-label fw-bolder">Telegram Image</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'telegram_image')"
                            [loadImage]="data.telegram_image" (deleteEvent)="delete($event, 'telegram_image')"
                            #telegramImage></app-image-uploader>
                    </div>

                    <hr />
                    <h3 class="mb-0 mt-3 fw-bolder">Chat Channels</h3>
                    <p class="mb-3 hint">Configure external messaging channels to receive and reply to messages from the unified chat inbox.</p>

                    <!-- WhatsApp Channel -->
                    <div class="card mb-3">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#25D366" viewBox="0 0 16 16">
                                    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                                </svg>
                                <strong>WhatsApp</strong>
                            </div>
                            <div class="d-flex align-items-center gap-2">
                                <span class="badge" [class.bg-success]="waStatus === 'connected'" [class.bg-warning]="waStatus === 'qr_needed'" [class.bg-danger]="waStatus === 'disconnected' || waStatus === 'not_configured'" [class.bg-secondary]="!waStatus">
                                    {{waStatus || 'Not Configured'}}
                                </span>
                            </div>
                        </div>
                        <div class="card-body">
                            <!-- Not configured / Disconnected -->
                            <div *ngIf="waStatus === 'not_configured' || waStatus === 'disconnected' || !waStatus">
                                <p class="text-muted mb-2">Connect your WhatsApp account to receive and reply to customer messages directly from the chat panel.</p>
                                <button class="btn btn-success btn-sm" (click)="initWhatsApp()" [disabled]="waLoading">
                                    <span *ngIf="!waLoading">Connect WhatsApp</span>
                                    <span *ngIf="waLoading">Initializing...</span>
                                </button>
                            </div>

                            <!-- QR Code -->
                            <div *ngIf="waStatus === 'qr_needed'" class="text-center">
                                <p class="mb-2">Scan this QR code with your WhatsApp mobile app:</p>
                                <p class="text-muted small mb-2">Open WhatsApp &gt; Settings &gt; Linked Devices &gt; Link a Device</p>
                                <div *ngIf="waQRCode" class="d-flex justify-content-center mb-3">
                                    <img [src]="waQRCode" alt="WhatsApp QR Code" style="max-width: 280px; border: 1px solid #ddd; border-radius: 8px; padding: 8px;" />
                                </div>
                                <div *ngIf="!waQRCode" class="d-flex justify-content-center mb-3">
                                    <div class="spinner-border text-success" role="status">
                                        <span class="visually-hidden">Loading QR...</span>
                                    </div>
                                </div>
                                <button class="btn btn-outline-secondary btn-sm" (click)="refreshWhatsAppQR()">Refresh QR</button>
                            </div>

                            <!-- Connected -->
                            <div *ngIf="waStatus === 'connected'">
                                <p class="text-success mb-2">WhatsApp is connected. Messages will appear in your chat inbox.</p>
                                <button class="btn btn-outline-danger btn-sm" (click)="disconnectWhatsApp()">Disconnect</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" [class.show]="selectedTab === 'registration'" [class.active]="selectedTab === 'registration'" id="registration" role="tabpanel" aria-labelledby="registration-tab">
                    <h3 class="mb-0 mt-3 fw-bolder">Registration</h3>
                    <p class="mb-3 hint">This is the registration information of the website. You can change the
                        registration settings.</p>
                    <div class="mb-3">
                        <label for="disabled_registration" class="form-label fw-bolder">Disabled Registration</label>
                        <select class="form-control" [(ngModel)]="data.disabled_registration"
                            name="disabled_registration" #disabled_registration="ngModel">
                            <option value="false">No</option>
                            <option value="true">Yes</option>
                        </select>
                        <p class="mb-0 hint">If you enable this, the user will not be able to publicly register.</p>
                    </div>
                    <div class="mb-3">
                        <label for="disabled_registration_captcha" class="form-label fw-bolder">Disabled Registration
                            Captcha</label>
                        <select class="form-control" [(ngModel)]="data.disabled_registration_captcha"
                            name="disabled_registration_captcha" #disabled_registration_captcha="ngModel">
                            <option value="false">No</option>
                            <option value="true">Yes</option>
                        </select>
                        <p class="mb-0 hint">If you enabled this, the user registeration will not using captcha.</p>
                    </div>
                    <div class="mb-3">
                        <label for="remove_nickname_on_registration" class="form-label fw-bolder">Remove Nickname On Registration</label>
                        <select class="form-control" [(ngModel)]="data.remove_nickname_on_registration"
                            name="remove_nickname_on_registration" #remove_nickname_on_registration="ngModel">
                            <option value="false">No</option>
                            <option value="true">Yes</option>
                        </select>
                        <p class="mb-0 hint">If you enable this, the nickname field will be hidden and set to same as player code.</p>
                    </div>
                    <div class="mb-3">
                        <label for="disabled_registration_confirm_password" class="form-label fw-bolder">Disabled Registration Confirm Password</label>
                        <select class="form-control" [(ngModel)]="data.disabled_registration_confirm_password"
                            name="disabled_registration_confirm_password" #disabled_registration_confirm_password="ngModel">
                            <option value="false">No</option>
                            <option value="true">Yes</option>
                        </select>
                        <p class="mb-0 hint">If you enable this, the confirm password field will be hidden during registration.</p>
                    </div>
                    <div class="mb-3">
                        <label for="register_tac_verification" class="form-label fw-bolder">Register TAC
                            Verification</label>
                        <select class="form-control" [(ngModel)]="data.register_tac_verification"
                            name="register_tac_verification" #register_tac_verification="ngModel">
                            <option value="false">No</option>
                            <option value="true">Yes</option>
                        </select>
                        <p class="mb-0 hint">If you enable this, the user will be required to verify their mobile number
                            before they can register.</p>
                    </div>
                    <div class="mb-3" *ngIf="data.register_tac_verification">
                        <label for="sms_provider" class="form-label fw-bolder">SMS Provider</label>
                        <select class="form-control" [(ngModel)]="data.sms_provider" name="sms_provider"
                            #sms_provider="ngModel">
                            <option value="default">System Default</option>
                            <option value="app">WW SMS APP</option>
                            <option value="whatsapp_web">Whatsapp WEB</option>
                            <option value="app_whatsapp_web">WW SMS APP + Whatsapp WEB</option>
                        </select>
                        <p *ngIf="data.sms_provider == 'app' || data.sms_provider == 'app_whatsapp_web'" class="mt-2">
                            Your API key for SMS is: <b>{{company_uuid}}</b><br>
                            <button class="btn btn-sm btn-primary mt-2" (click)="generatePairingCode()">Generate Pairing Code</button>
                            <a [href]="'/api/ww-sms.apk?company_uuid=' + company_uuid" download class="btn btn-sm btn-outline-info mt-2 ms-2">Download Gateway App</a>
                        </p>
                        <div *ngIf="pairingCode" class="alert alert-info mt-2">
                            Pairing Code: <b style="font-size: 1.5rem;">{{pairingCode}}</b><br>
                            <small>Expires in 15 minutes. Enter this code in the Android App.</small>
                        </div>
                        <div *ngIf="data.sms_provider == 'app' || data.sms_provider == 'app_whatsapp_web'" class="mt-2">
                            <app-checbox [setData]="data" [key]="'sms_prepend_plus'" [title]="'Add + in front of phone number'" [value]="true"></app-checbox>
                            <p class="mb-0 hint">Prepends '+' to the mobile number before sending (e.g. 60123456789 → +60123456789).</p>
                        </div>
                        <div *ngIf="data.sms_provider == 'app' || data.sms_provider == 'app_whatsapp_web'" class="mt-2">
                            <label for="sms_strip_prefix_length" class="form-label fw-bolder">Strip leading digits from phone number</label>
                            <input type="number" class="form-control" id="sms_strip_prefix_length" placeholder="0" name="sms_strip_prefix_length" #sms_strip_prefix_length="ngModel" [(ngModel)]="data.sms_strip_prefix_length" min="0" max="10" />
                            <p class="mb-0 hint">Number of digits to remove from the front before sending (e.g. 1 turns 0123456789 → 123456789). Leave 0 to disable.</p>
                        </div>
                        <div *ngIf="data.sms_provider == 'whatsapp_web' || data.sms_provider == 'app_whatsapp_web'" class="mt-3">
                            <div class="d-flex align-items-center gap-2 mb-2">
                                <span class="fw-bolder">WhatsApp Status:</span>
                                <span *ngIf="tacWaStatus === 'linked'" class="badge bg-success">Linked</span>
                                <span *ngIf="tacWaStatus === 'not_linked'" class="badge bg-secondary">Not Linked</span>
                                <span *ngIf="tacWaStatus === 'qr_pending'" class="badge bg-warning text-dark">Scan QR</span>
                                <span *ngIf="tacWaStatus === 'loading' || tacWaStatus === 'unknown'" class="badge bg-info">Loading...</span>
                            </div>
                            <div *ngIf="tacWaStatus === 'qr_pending' && tacWaQRCode" class="mb-2">
                                <p class="mb-1 text-muted small">Open WhatsApp → Settings → Linked Devices → Link a Device</p>
                                <img [src]="tacWaQRCode" alt="WhatsApp QR Code" style="max-width: 220px; border: 1px solid #ddd; border-radius: 8px; padding: 6px;" />
                            </div>
                            <div *ngIf="tacWaStatus === 'qr_pending' && !tacWaQRCode" class="mb-2 text-muted small">
                                Waiting for QR code...
                            </div>
                            <button *ngIf="tacWaStatus === 'not_linked' || tacWaStatus === 'unknown'"
                                type="button" class="btn btn-sm btn-success"
                                (click)="initTacWhatsApp()" [disabled]="tacWaLoading">
                                {{ tacWaLoading ? 'Initializing...' : 'Link WhatsApp' }}
                            </button>
                            <button *ngIf="tacWaStatus === 'linked'"
                                type="button" class="btn btn-sm btn-danger"
                                (click)="logoutTacWhatsApp()" [disabled]="tacWaLoading">
                                {{ tacWaLoading ? 'Logging out...' : 'Logout WhatsApp' }}
                            </button>
                            <div class="alert alert-info mt-2 mb-0 p-2">
                                <small>Company ID: <b>{{company_uuid}}</b></small>
                            </div>

                            <div *ngIf="tacWaStatus === 'linked'" class="mt-3 p-3 border rounded">
                                <label class="form-label fw-bolder mb-1">Send Test Message</label>
                                <p class="mb-2 hint">Send a WhatsApp message from this company's linked session to verify the integration.</p>
                                <div class="mb-2">
                                    <input type="text" class="form-control" placeholder="Phone number (e.g. +60123456789 or 0123456789)"
                                           name="tacWaTestPhone" [(ngModel)]="tacWaTestPhone" maxlength="20" />
                                </div>
                                <div class="mb-2">
                                    <textarea class="form-control" rows="3" placeholder="Message text"
                                              name="tacWaTestMessage" [(ngModel)]="tacWaTestMessage" maxlength="1000"></textarea>
                                </div>
                                <button type="button" class="btn btn-sm btn-primary"
                                        (click)="sendTacTestMessage()" [disabled]="tacWaTestSending">
                                    {{ tacWaTestSending ? 'Sending...' : 'Send Test Message' }}
                                </button>
                                <div *ngIf="tacWaTestResult" class="mt-2 mb-0 alert p-2"
                                     [class.alert-success]="tacWaTestResult.ok" [class.alert-danger]="!tacWaTestResult.ok">
                                    <small>{{ tacWaTestResult.message }}</small>
                                </div>
                            </div>
                        </div>
                        <p class="mb-0 hint">This is the default language of the website. It will be displayed in the
                            website.</p>
                    </div>
                    <div class="mb-3">
                        <label for="mobile_number_validator" class="form-label fw-bolder">Mobile Number Validator
                            (Regex)</label>
                        <input type="text" class="form-control" id="mobile_number_validator"
                            placeholder="Enter Mobile Number Validator" name="mobile_number_validator"
                            #mobile_number_validator="ngModel" [(ngModel)]="data.mobile_number_validator"
                            maxlength="255" />
                        <p class="mb-0 hint">Example:</p>
                        <ul>
                            <li>{{'^[0-9]\{7,15\}$'}} 至少7位数字， 最多15位数字。这不包括country code 比如+60</li>
                            <li>{{'^[0-9]\{8,10\}$'}} 至少8位数字， 最多10位数字。这不包括country code 比如+60</li>
                        </ul>
                    </div>
                    <div class="mb-3">
                        <label for="mobile_number_country_code" class="form-label fw-bolder">Mobile Number Country Code
                            (multiple country code split by |)</label>
                        <input type="text" class="form-control" id="mobile_number_country_code"
                            placeholder="Enter Mobile Number Country Code" name="mobile_number_country_code"
                            #mobile_number_country_code="ngModel" [(ngModel)]="data.mobile_number_country_code"
                            maxlength="255" />
                        <p class="mb-0 hint">Example:</p>
                        <ul>
                            <li>{{'60|65|675'}} 可以接受三个号码：马来西亚号码+60 或者新加坡号码+65 或者 Papua New Guinea号码+675</li>
                            <li>{{'60|675'}} 可以接受两个号码：马来西亚号码+60 或者 Papua New Guinea号码 +675</li>
                            <li>{{'60'}} 只是可以接受马来西亚号码+60而已</li>
                        </ul>
                    </div>
                    <div class="mb-3">
                        <label for="mobile_number_placeholder" class="form-label fw-bolder">Mobile Number
                            Placeholder</label>
                        <input type="text" class="form-control" id="mobile_number_placeholder"
                            placeholder="Enter Mobile Number Placeholder" name="mobile_number_placeholder"
                            #mobile_number_placeholder="ngModel" [(ngModel)]="data.mobile_number_placeholder"
                            maxlength="30" />
                        <p class="mb-0 hint">This is the placeholder for the mobile number input field. It will be
                            displayed when the user is registering. Example: "171234567"</p>
                    </div>
                </div>
                <div class="tab-pane fade" [class.show]="selectedTab === 'credit'" [class.active]="selectedTab === 'credit'" id="credit" role="tabpanel" aria-labelledby="credit-tab">
                    <h3>Credit</h3>
                    <div class="mb-3">
                        <label for="credit_label" class="form-label fw-bolder">Credit Label</label>
                        <input type="text" class="form-control" id="credit_label" placeholder="Credit Label"
                            name="credit_label" #credit_label="ngModel" [(ngModel)]="data.credit_label"
                            maxlength="35" />
                    </div>
                    <div class="mb-3">
                        <label for="credit_calculation_method" class="form-label fw-bolder">Credit Calculation
                            Method</label>
                        <select class="form-control" [(ngModel)]="data.credit_calculation_method"
                            name="credit_calculation_method" #credit_calculation_method="ngModel">
                            <option value="auto">Auto</option>
                            <option value="manual">Manual Entry</option>
                        </select>
                    </div>
                    <div class="mb-3" *ngIf="data.credit_calculation_method == 'auto'">
                        <label for="credit_calculation_rate" class="form-label fw-bolder">Credit Calculation Rate
                            (%)</label>
                        <input type="number" class="form-control" id="credit_calculation_rate"
                            placeholder="Credit Calculation Rate" name="credit_calculation_rate"
                            #credit_calculation_rate="ngModel" [(ngModel)]="data.credit_calculation_rate"
                            maxlength="15" />
                    </div>
                </div>
                <div class="tab-pane fade" [class.show]="selectedTab === 'promotion'" [class.active]="selectedTab === 'promotion'" id="promotion" role="tabpanel" aria-labelledby="promotion-tab">
                    <h3 class="mb-0 mt-3 fw-bolder">Promotion</h3>
                    <p class="mb-3 hint">This is the promotion settings of the website. You can change the promotion
                        settings.</p>
                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'disabled_promotion'" [title]="'Disabled Promotion'"
                            [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, the promotion will be disabled on the website.</p>
                    </div>
                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'disable_unclaimed_promotion_popup'"
                            [title]="'Disable Automatic Unclaimed Promotion Popup'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">Promotions remain visible and claimable in the Promo tab, but game launches will not show the automatic unclaimed-promotion popup.</p>
                    </div>
                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'promotion_hide_category'"
                            [title]="'Promotion Hide Category'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, the promotion will be hide category information.</p>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <div class="mb-3">
                                <label for="inactive_promotion_heading_line_1" class="form-label fw-bolder">Inactive Promotion Heading Line 1</label>
                                <input type="text" class="form-control" id="inactive_promotion_heading_line_1"
                                    placeholder="No Active Promotion" name="inactive_promotion_heading_line_1"
                                    #inactive_promotion_heading_line_1="ngModel"
                                    [(ngModel)]="data.inactive_promotion_heading_line_1" />
                                <p class="mb-0 hint">Shown on the promotion page when there is no active promotion.</p>
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <div class="mb-3">
                                <label for="inactive_promotion_heading_line_2" class="form-label fw-bolder">Inactive Promotion Heading Line 2</label>
                                <input type="text" class="form-control" id="inactive_promotion_heading_line_2"
                                    placeholder="Second heading line" name="inactive_promotion_heading_line_2"
                                    #inactive_promotion_heading_line_2="ngModel"
                                    [(ngModel)]="data.inactive_promotion_heading_line_2" />
                                <p class="mb-0 hint">Optional second line under the inactive promotion heading.</p>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'disabled_cancel_promotion'"
                            [title]="'Disabled Cancel Promotion Button / 禁用取消优惠活动按钮'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, the promotion cancel button will be disabled on the
                            website. (Cancel Promotion button will be hidden) <br>
                            如果启用此选项，取消优惠活动的按钮将在网站上禁用。（取消优惠活动按钮将被隐藏）</p>
                    </div>
                    <div class="mb-3" *ngIf="!data.disabled_cancel_promotion">
                        <app-checbox [setData]="data" [key]="'do_not_forfit_player_wallet_balance_on_cancel_promotion'"
                            [title]="'Do not forfit player wallet balance on cancel promotion / 取消优惠活动后不清空玩家钱包余额'"
                            [value]="true"></app-checbox>
                        <p class="mb-0 hint">By default, user wallet balance will be forfit and become 0 on cancel
                            promotion. If you enable this, if user cancel promotion, his wallet will not become 0. The
                            balance will be kept . 默认情况下，用户在取消优惠活动后，其钱包余额将被清空为0。如果启用此选项，用户在取消优惠活动后，其钱包余额将保持不变，不会清空为0。
                        </p>
                    </div>
                    <div class="mb-3" *ngIf="!data.promotion_hide_category">
                        <app-checbox [setData]="data" [key]="'promotion_group_header_showby_image'"
                            [title]="'Promotion Group Header Showby Image'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, the promotion group header will be displayed by image.
                            Else it will be displayed by text.</p>
                    </div>
                    <div class="mb-3"
                        *ngIf="!data.promotion_hide_category && !data.promotion_group_header_showby_image">
                        <label for="promotion_group_header_background_color" class="form-label fw-bolder">Promotion
                            Group Header Background Color</label>
                        <input type="text" class="form-control" id="promotion_group_header_background_color"
                            placeholder="Enter Promotion Group Header Background Color"
                            name="promotion_group_header_background_color"
                            #promotion_group_header_background_color="ngModel"
                            [(ngModel)]="data.promotion_group_header_background_color" />
                        <p class="mb-0 hint">This is the background color of the promotion group header. Example:
                            #000000 / rgb(0, 0, 0) / rgba(0, 0, 0, 0.5)</p>
                    </div>
                    <div class="mb-3"
                        *ngIf="!data.promotion_hide_category && !data.promotion_group_header_showby_image">
                        <label for="promotion_group_header_text_color" class="form-label fw-bolder">Promotion Group
                            Header Text Color</label>
                        <input type="text" class="form-control" id="promotion_group_header_text_color"
                            placeholder="Enter Promotion Group Header Text Color"
                            name="promotion_group_header_text_color" #promotion_group_header_text_color="ngModel"
                            [(ngModel)]="data.promotion_group_header_text_color" />
                        <p class="mb-0 hint">This is the text color of the promotion group header. Example: #000000 /
                            rgb(0, 0, 0) / rgba(0, 0, 0, 0.5)</p>
                    </div>
                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'disabled_promotion_on_unfullfilled_condition'"
                            [title]="'Disabled Promotion On Unfullfilled Condition'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, the promotion will be disabled if the user does not
                            meet the condition. (Greyout the promotion)</p>
                    </div>
                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'show_unlogin_user_promotion'"
                            [title]="'Show user promotion T&C without need to login'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, user can view promotion even not login.</p>
                    </div>
                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'show_unlogin_user_promotion_greyout'"
                            [title]="'Greyout Promotion + Show T&C on click (Non-Login)'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">Promotion cards appear greyed out for non-logged-in users. Clicking still shows the T&C.</p>
                    </div>
                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'disabled_promotion_on_unlogin'"
                            [title]="'Greyout Promotion + Block Click (Non-Login)'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">Promotion cards appear greyed out for non-logged-in users. Clicking does nothing — no redirect, no detail shown.</p>
                    </div>


                    <hr />
                    <div class="mb-3">
                        <label for="promotion_layout_square" class="form-label fw-bolder">Promotion Layout
                            Square</label>
                        <select class="form-control" [(ngModel)]="data.promotion_layout_square"
                            name="promotion_layout_square" #promotion_layout_square="ngModel">
                            <option value="">Free Scale (Default)</option>
                            <option value="1/1">1/1</option>
                            <option value="4/3">4/3</option>
                            <option value="16/9">16/9</option>
                            <option value="21/9">21/9</option>
                            <option value="9/16">9/16</option>
                            <option value="1/2">1/2</option>
                            <option value="2/1">2/1</option>
                            <option value="3/4">3/4</option>
                        </select>
                        <p class="mb-0 hint">This is the layout of the promotion. 1/1 is the square layout, 4/3 is the
                            4:3 ratio, and 16/9 is the 16:9 ratio.</p>
                    </div>

                    <!-- <div class="mb-3">
                        <label for="promotion_category_image_size" class="form-label fw-bolder">Promotion Category Image Size</label>
                        <select class="form-control" [(ngModel)]="data.promotion_category_image_size" name="promotion_category_image_size" #promotion_category_image_size="ngModel">
                            <option value="1/1">1/1</option>
                            <option value="4/3">4/3</option>
                            <option value="16/9">16/9</option>
                            <option value="21/9">21/9</option>
                            <option value="9/16">9/16</option>
                            <option value="1/2">1/2</option>
                            <option value="2/1">2/1</option>
                            <option value="3/4">3/4</option>
                        </select>
                        <p class="mb-0 hint">This is the layout of the promotion. 1/1 is the square layout, 4/3 is the 4:3 ratio, and 16/9 is the 16:9 ratio.</p>
                    </div> -->

                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'promotion_layout_hide_title'"
                            [title]="'Promotion Layout Hide Title'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, the promotion title will be hidden.</p>
                    </div>

                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'promotion_layout_hide_description'"
                            [title]="'Promotion Layout Hide Description'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, the promotion description will be hidden.</p>
                    </div>

                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'promotion_layout_center'"
                            [title]="'Promotion Layout Centered'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, the promotion title content & description will be
                            centered.</p>
                    </div>

                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'promotion_layout_hide_category_image'"
                            [title]="'Promotion Layout Hide Category Image'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, the promotion category image will be hidden.</p>
                    </div>


                    <div class="mb-3">
                        <label for="promotion_title_color" class="form-label fw-bolder">Promotion Title Color</label>
                        <input type="text" class="form-control" id="promotion_title_color"
                            placeholder="Enter Promotion Title Color" name="promotion_title_color"
                            #promotion_title_color="ngModel" [(ngModel)]="data.promotion_title_color" />
                        <p class="mb-0 hint">This is the color of the promotion title. Example: #000000 / rgb(0, 0, 0) /
                            rgba(0, 0, 0, 0.5)</p>
                    </div>

                    <div class="mb-3">
                        <label for="promotion_description_color" class="form-label fw-bolder">Promotion Description
                            Color</label>
                        <input type="text" class="form-control" id="promotion_description_color"
                            placeholder="Enter Promotion Description Color" name="promotion_description_color"
                            #promotion_description_color="ngModel" [(ngModel)]="data.promotion_description_color" />
                        <p class="mb-0 hint">This is the color of the promotion description. Example: #000000 / rgb(0,
                            0, 0) / rgba(0, 0, 0, 0.5)</p>
                    </div>

                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'promotion_popup_hide_image'"
                            [title]="'Promotion Popup Hide Image'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, the promotion popup image will be hidden.</p>
                    </div>

                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'promotion_popup_hide_description'"
                            [title]="'Promotion Popup Hide Description'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, the promotion popup description will be hidden.</p>
                    </div>

                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'promotion_popup_hide_tnc'"
                            [title]="'Promotion Popup Hide TNC'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, the promotion popup T&C will be hidden.</p>
                    </div>

                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'show_promotion_vip_popup'"
                            [title]="'Show Promotion VIP Popup'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, the promotion VIP popup will be shown.</p>
                    </div>

                    <div class="mb-3" *ngIf="data.show_promotion_vip_popup">
                        <label for="promotion_vip_note" class="form-label fw-bolder">Promotion VIP Note</label>
                        <quill-editor [format]="'html'" [(ngModel)]="data.promotion_vip_note" [required]="true"
                            [styles]="{minHeight: '250px'}"
                            (onEditorCreated)="editorCreated($event, 'promotion_vip_note')"></quill-editor>
                        <p class="mb-0 hint">This is the note that will be shown to the user when they are in the
                            promotion VIP page / section.</p>
                    </div>

                    <div class="mb-3" *ngIf="data.show_promotion_vip_popup">
                        <label for="promotion_vip_background_color" class="form-label fw-bolder">Promotion VIP
                            Background Color</label>
                        <input type="text" class="form-control" id="promotion_vip_background_color"
                            placeholder="Enter Promotion VIP Background Color" name="promotion_vip_background_color"
                            #promotion_vip_background_color="ngModel"
                            [(ngModel)]="data.promotion_vip_background_color" />
                        <p class="mb-0 hint">This is the background color of the promotion VIP popup. Example: #000000 /
                            rgb(0, 0, 0) / rgba(0, 0, 0, 0.5)</p>
                    </div>

                    <div class="mb-3" *ngIf="data.show_promotion_vip_popup">
                        <label for="promotion_vip_text_color" class="form-label fw-bolder">Promotion VIP Text
                            Color</label>
                        <input type="text" class="form-control" id="promotion_vip_text_color"
                            placeholder="Enter Promotion VIP Text Color" name="promotion_vip_text_color"
                            #promotion_vip_text_color="ngModel" [(ngModel)]="data.promotion_vip_text_color" />
                        <p class="mb-0 hint">This is the text color of the promotion VIP popup. Example: #000000 /
                            rgb(0, 0, 0) / rgba(0, 0, 0, 0.5)</p>
                    </div>

                    <hr />
                    <div class="mb-3">
                        <label for="promotion_cancellation_note" class="form-label fw-bolder">Promotion Cancellation
                            Note</label>
                        <quill-editor [format]="'html'" [(ngModel)]="data.promotion_cancellation_note" [required]="true"
                            [styles]="{minHeight: '250px'}"
                            (onEditorCreated)="editorCreated($event, 'promotion_cancellation_note')"></quill-editor>
                        <p class="mb-0 hint">This is the note that will be shown to the user when they are in the
                            promotion cancellation section.</p>
                    </div>
                </div>
                <div class="tab-pane fade" [class.show]="selectedTab === 'design'" [class.active]="selectedTab === 'design'" id="design" role="tabpanel" aria-labelledby="design-tab">

                    <div class="mb-3">
                        <label class="form-label fw-bolder">Mobile Game Categories</label>
                        <app-checbox [setData]="data" [key]="'mobile_category_wrap'"
                            [title]="'Wrap Categories to Next Line'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">For Dashboard landing (Style 03), show every game category on multiple rows on mobile instead of requiring horizontal scrolling. Desktop remains a single row.</p>
                    </div>

                    <div class="mb-3">
                        <label for="random_transaction" class="form-label fw-bolder">Random Live Transaction</label>
                        <app-checbox [setData]="data" [key]="'random_transaction'" [title]="'Random Transaction'"
                            [value]="true"></app-checbox>
                        <p class="mb-0 hint">If you enable this, the transaction will be random.</p>
                    </div>

                    <div class="mb-3">
                        <label for="background_image" class="form-label fw-bolder">Background Image</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'background_image')"
                            (deleteEvent)="delete($event, 'background_image')" #backgroundImage></app-image-uploader>
                        <p class="mb-0 hint">This is the background image of the website.</p>
                    </div>

                    <div class="mb-3">
                        <label for="background_color" class="form-label fw-bolder">Background Color</label>
                        <input type="text" class="form-control" id="background_color"
                            placeholder="Enter Background Color" name="background_color" #background_color="ngModel"
                            [(ngModel)]="data.background_color" />
                        <p class="mb-0 hint">This is the background color of the website. Example: #000000 / rgb(0, 0,
                            0) / rgba(0, 0, 0, 0.5)</p>
                    </div>

                    <div class="mb-3">
                        <label for="header_background_color" class="form-label fw-bolder">Header Background
                            Color</label>
                        <input type="text" class="form-control" id="header_background_color"
                            placeholder="Enter Header Background Color" name="header_background_color"
                            #header_background_color="ngModel" [(ngModel)]="data.header_background_color" />
                        <p class="mb-0 hint">This is the background color of the header. Example: #000000 / rgb(0, 0, 0)
                            / rgba(0, 0, 0, 0.5)</p>
                    </div>

                    <div class="mb-3">
                        <label class="form-label fw-bolder">Desktop Header Background Image</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'header_desktop_background_image', true)"
                            [loadImage]="data.header_desktop_background_image"
                            (deleteEvent)="delete($event, 'header_desktop_background_image')"
                            #headerDesktopBackgroundImage></app-image-uploader>
                        <p class="mb-0 hint">Optional desktop-only image background for the app header.</p>
                    </div>

                    <div class="mb-3">
                        <label for="header_desktop_background_height" class="form-label fw-bolder">Desktop Header Background Height</label>
                        <input type="text" class="form-control" id="header_desktop_background_height"
                            placeholder="Example: 90px" name="header_desktop_background_height"
                            #header_desktop_background_height="ngModel" [(ngModel)]="data.header_desktop_background_height" />
                        <p class="mb-0 hint">Optional. Use px/rem/vh, or enter a number to save as px.</p>
                    </div>

                    <div class="mb-3">
                        <label for="header_desktop_background_size" class="form-label fw-bolder">Desktop Header Background Size</label>
                        <select class="form-select" id="header_desktop_background_size" name="header_desktop_background_size"
                            #header_desktop_background_size="ngModel" [(ngModel)]="data.header_desktop_background_size">
                            <option value="">Default Cover</option>
                            <option value="cover">Cover</option>
                            <option value="contain">Contain</option>
                            <option value="100% auto">100% Width</option>
                            <option value="auto 100%">100% Height</option>
                        </select>
                    </div>

                    <div class="mb-3">
                        <label class="form-label fw-bolder">Mobile Header Background Image</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'header_mobile_background_image', true)"
                            [loadImage]="data.header_mobile_background_image || data.header_background_image"
                            (deleteEvent)="delete($event, 'header_mobile_background_image')"
                            #headerMobileBackgroundImage></app-image-uploader>
                        <p class="mb-0 hint">Mobile-only image background for the app header. Existing header image is shown here as fallback.</p>
                    </div>

                    <div class="mb-3">
                        <label for="header_mobile_background_height" class="form-label fw-bolder">Mobile Header Background Height</label>
                        <input type="text" class="form-control" id="header_mobile_background_height"
                            placeholder="Example: 90px" name="header_mobile_background_height"
                            #header_mobile_background_height="ngModel" [(ngModel)]="data.header_mobile_background_height" />
                        <p class="mb-0 hint">Optional. Use px/rem/vh, or enter a number to save as px.</p>
                    </div>

                    <div class="mb-3">
                        <label for="header_mobile_background_size" class="form-label fw-bolder">Mobile Header Background Size</label>
                        <select class="form-select" id="header_mobile_background_size" name="header_mobile_background_size"
                            #header_mobile_background_size="ngModel" [(ngModel)]="data.header_mobile_background_size">
                            <option value="">Default Cover</option>
                            <option value="cover">Cover</option>
                            <option value="contain">Contain</option>
                            <option value="100% auto">100% Width</option>
                            <option value="auto 100%">100% Height</option>
                        </select>
                    </div>

                    <div class="mb-3">
                        <label class="form-label fw-bolder">Header Left Button Image</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'header_left_button_image', true)"
                            [loadImage]="data.header_left_button_image"
                            (deleteEvent)="delete($event, 'header_left_button_image')"
                            #headerLeftButtonImage></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label class="form-label fw-bolder">Header Left Popup Images</label>
                        <app-image-uploader [type]="'multiple'" (uploadEvent)="upload($event, 'header_left_popup_images')"
                            (deleteEvent)="delete($event, 'header_left_popup_images')"
                            #headerLeftPopupImages></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label class="form-label fw-bolder">Header Right Button Image</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'header_right_button_image', true)"
                            [loadImage]="data.header_right_button_image"
                            (deleteEvent)="delete($event, 'header_right_button_image')"
                            #headerRightButtonImage></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label class="form-label fw-bolder">Header Right Popup Images</label>
                        <app-image-uploader [type]="'multiple'" (uploadEvent)="upload($event, 'header_right_popup_images')"
                            (deleteEvent)="delete($event, 'header_right_popup_images')"
                            #headerRightPopupImages></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <h5 class="mb-1 fw-bolder">Partnership Button</h5>
                        <p class="mb-2 hint">Show a partnership button in the header navigation.</p>
                        <app-checbox [setData]="data" [key]="'show_partnership_btn'" [title]="'Show Partnership Button'" [value]="true"></app-checbox>
                    </div>
                    <div class="mb-3" *ngIf="data.show_partnership_btn">
                        <label class="form-label fw-bolder">Partnership Button Image</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'partnership_btn_image', true)"
                            (deleteEvent)="delete($event, 'partnership_btn_image')" #partnershipBtnImage></app-image-uploader>
                        <p class="mb-0 hint">Optional. If set, shows this image instead of the text label.</p>
                    </div>

                    <div class="mb-3">
                        <label for="partnership_image_container_background_color" class="form-label fw-bolder">
                            Partnership Image Container Background
                        </label>
                        <div class="input-group">
                            <span class="input-group-text p-1">
                                <span
                                    class="rounded border"
                                    style="display: block; width: 1.75rem; height: 1.75rem;"
                                    [style.background-color]="data.partnership_image_container_background_color || 'transparent'"
                                ></span>
                            </span>
                            <input
                                type="text"
                                class="form-control"
                                id="partnership_image_container_background_color"
                                name="partnership_image_container_background_color"
                                placeholder="Theme default or #ffffff"
                                [(ngModel)]="data.partnership_image_container_background_color"
                            />
                        </div>
                        <p class="mb-0 hint">
                            Sets the background behind partnership logos. Use a CSS color such as #ffffff or rgba(255, 255, 255, 0.9). Leave empty to use the theme-aware default.
                        </p>
                    </div>

                    <div class="card border-0 shadow-sm mb-3">
                        <div class="card-body">
                            <label class="form-label fw-bolder">Terms & Conditions Image</label>
                            <p class="mb-1 hint">Upload a T&C image. A button will appear in the website header linking to this image. Leave empty to hide the button.</p>
                            <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'tnc_image')"
                                [loadImage]="data.tnc_image" (deleteEvent)="delete($event, 'tnc_image')">
                            </app-image-uploader>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="footer_background_color" class="form-label fw-bolder">Footer Background
                            Color</label>
                        <input type="text" class="form-control" id="footer_background_color"
                            placeholder="Enter Footer Background Color" name="footer_background_color"
                            #footer_background_color="ngModel" [(ngModel)]="data.footer_background_color" />
                        <p class="mb-0 hint">This is the background color of the footer. Example: #000000 / rgb(0, 0, 0)
                            / rgba(0, 0, 0, 0.5)</p>
                    </div>

                    <hr />
                    <div>
                        <h5 class="mb-0 mt-3 fw-bolder">Marquee</h5>
                        <p class="mb-3 hint">This is the marquee settings of the website. You can change the marquee
                            settings.</p>
                        <div class="mb-3">
                            <label for="marquee_text" class="form-label fw-bolder">Marquee Text</label>
                            <input type="text" class="form-control" id="marquee_text" placeholder="Enter Marquee Text"
                                name="marquee_text" #marquee_text="ngModel" [(ngModel)]="data.marquee_text" />
                            <p class="mb-0 hint">This is the text of the marquee. Example: "Welcome to the website"</p>
                        </div>
                        <div class="mb-3">
                            <label for="marquee_background_image" class="form-label fw-bolder">Marquee Background
                                Image</label>
                            <app-image-uploader [type]="'single'"
                                (uploadEvent)="upload($event, 'marquee_background_image')"
                                (deleteEvent)="delete($event, 'marquee_background_image')"
                                #marqueeBackgroundImage></app-image-uploader>
                            <p class="mb-0 hint">This is the background image of the marquee.</p>
                        </div>
                        <div class="mb-3">
                            <label for="marquee_background_color" class="form-label fw-bolder">Marquee Background
                                Color</label>
                            <input type="text" class="form-control" id="marquee_background_color"
                                placeholder="Enter Marquee Background Color" name="marquee_background_color"
                                #marquee_background_color="ngModel" [(ngModel)]="data.marquee_background_color" />
                            <p class="mb-0 hint">This is the background color of the marquee. Example: #000000 / rgb(0,
                                0, 0) / rgba(0, 0, 0, 0.5)</p>
                        </div>
                        <div class="mb-3">
                            <label for="marquee_border_color" class="form-label fw-bolder">Marquee Border Color</label>
                            <input type="text" class="form-control" id="marquee_border_color"
                                placeholder="Enter Marquee Border Color" name="marquee_border_color"
                                #marquee_border_color="ngModel" [(ngModel)]="data.marquee_border_color" />
                            <p class="mb-0 hint">This is the border color of the marquee. Example: #000000 / rgb(0, 0,
                                0) / rgba(0, 0, 0, 0.5)</p>
                        </div>
                        <div class="mb-3">
                            <label for="marquee_text_color" class="form-label fw-bolder">Marquee Text Color</label>
                            <input type="text" class="form-control" id="marquee_text_color"
                                placeholder="Enter Marquee Text Color" name="marquee_text_color"
                                #marquee_text_color="ngModel" [(ngModel)]="data.marquee_text_color" />
                            <p class="mb-0 hint">This is the text color of the marquee. Example: #000000 / rgb(0, 0, 0)
                                / rgba(0, 0, 0, 0.5)</p>
                        </div>
                    </div>
                    <hr />

                    <div>
                        <h5 class="mb-0 mt-3 fw-bolder">Game Settings</h5>
                        <p class="mb-3 hint">This is the game settings of the website.</p>

                        <div class="mb-3">
                            <label for="game_layout_per_row" class="form-label fw-bolder">Game Layout Per Row</label>
                            <select class="form-control" [(ngModel)]="data.game_layout_per_row"
                                name="game_layout_per_row" #game_layout_per_row="ngModel">
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                            </select>
                            <p class="mb-0 hint">This is the number of games per row. Example: 4</p>
                        </div>

                        <div class="mb-3">
                            <label for="game_layout_per_row_on_mobile" class="form-label fw-bolder">Game Layout Per Row
                                On Mobile</label>
                            <select class="form-control" [(ngModel)]="data.game_layout_per_row_on_mobile"
                                name="game_layout_per_row_on_mobile" #game_layout_per_row_on_mobile="ngModel">
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                            </select>
                            <p class="mb-0 hint">This is the number of games per row on mobile. Example: 1</p>
                        </div>

                        <div class="mb-3">
                            <label for="supplier_game_layout_per_row" class="form-label fw-bolder">Supplier Game Layout
                                Per Row</label>
                            <select class="form-control" [(ngModel)]="data.supplier_game_layout_per_row"
                                name="supplier_game_layout_per_row" #supplier_game_layout_per_row="ngModel">
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                            </select>
                            <p class="mb-0 hint">This is the number of games per row. Example: 4</p>
                        </div>

                        <div class="mb-3">
                            <label for="supplier_game_layout_per_row_on_mobile" class="form-label fw-bolder">Supplier
                                Game Layout Per Row On Mobile</label>
                            <select class="form-control" [(ngModel)]="data.supplier_game_layout_per_row_on_mobile"
                                name="supplier_game_layout_per_row_on_mobile"
                                #supplier_game_layout_per_row_on_mobile="ngModel">
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                            </select>
                            <p class="mb-0 hint">This is the number of supplier games per row on mobile. Example: 1</p>
                        </div>
                    </div>

                    <hr />
                    <div class="mb-3">
                        <label for="dbanner" class="form-label fw-bolder">Image Slider</label>
                        <app-image-uploader [type]="'multiple'" (uploadEvent)="upload($event, 'dbanner')"
                            (deleteEvent)="delete($event, 'dbanner')" #dbanner></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label for="payment_method_image" class="form-label fw-bolder">Payment Method Image</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'payment_method_image')"
                            (deleteEvent)="delete($event, 'payment_method_image')"
                            #paymentMethodImage></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label for="promobanner" class="form-label fw-bolder">Promo Banner</label>
                        <app-image-uploader [type]="'multiple'" (uploadEvent)="upload($event, 'promobanner')"
                            [loadImage]="data.promobanner" (deleteEvent)="delete($event, 'promobanner')"
                            #promobanner></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label for="lucky_draw_image" class="form-label fw-bolder">Lucky Draw Image</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'lucky_draw_image')"
                            (deleteEvent)="delete($event, 'lucky_draw_image')" #luckydrawImage></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label for="lucky_draw_page_images" class="form-label fw-bolder">Lucky Draw Image Page Images</label>
                        <app-image-uploader [type]="'multiple'" (uploadEvent)="upload($event, 'lucky_draw_page_images')"
                            [loadImage]="data.lucky_draw_page_images" (deleteEvent)="delete($event, 'lucky_draw_page_images')"
                            #luckyDrawPageImages></app-image-uploader>
                        <p class="mb-0 hint">Images shown on the footer Lucky Draw image page. The page displays images only.</p>
                    </div>

                    <div class="mb-3">
                        <label for="popupbanner1" class="form-label fw-bolder">Popup 1 Banner</label>
                        <app-image-uploader [type]="'multiple'" (uploadEvent)="upload($event, 'popupbanner1')"
                            (deleteEvent)="delete($event, 'popupbanner1')" #popupbanner1></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label for="popupbanner2" class="form-label fw-bolder">Popup 2 Banner</label>
                        <app-image-uploader [type]="'multiple'" (uploadEvent)="upload($event, 'popupbanner2')"
                            (deleteEvent)="delete($event, 'popupbanner2')" #popupbanner2></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label for="more_info_images" class="form-label fw-bolder">More Info images</label>
                        <app-image-uploader [type]="'multiple'" (uploadEvent)="upload($event, 'more_info_images')"
                            (deleteEvent)="delete($event, 'more_info_images')" #more_info_images></app-image-uploader>
                    </div>
                    <!-- 
                    <div class="mb-3" >
                        <label for="mbanner" class="form-label fw-bolder">Mobile Slider</label>
                        <app-image-uploader [type]="'multiple'" (uploadEvent)="upload($event, 'mbanner')" (deleteEvent)="delete($event, 'mbanner')" #mbanner></app-image-uploader>
                    </div>
        
                    <div class="mb-3" >
                        <label for="dashboardBanner" class="form-label fw-bolder">Landing Banner</label>
                        <app-image-uploader [type]="'multiple'" (uploadEvent)="upload($event, 'landing_banner')" (deleteEvent)="delete($event, 'landing_banner')" #landingBanner></app-image-uploader>
                    </div> -->


                    <hr />


                    <div class="mb-3">
                        <label for="login_card" class="form-label fw-bolder">Login Card Background</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'login_card')"
                            [loadImage]="data.login_card" (deleteEvent)="delete($event, 'login_card')"
                            #loginCard></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label for="login_card_text_color" class="form-label fw-bolder">Login Card Text Color</label>
                        <input type="text" class="form-control" id="login_card_text_color"
                            placeholder="Login Card Text Color" name="login_card_text_color"
                            #login_card_text_color="ngModel" [(ngModel)]="data.login_card_text_color" />
                    </div>

                    <div class="mb-3">
                        <label for="login_card_background_size" class="form-label fw-bolder">Login Card Background Size</label>
                        <select class="form-select" id="login_card_background_size" name="login_card_background_size"
                            #login_card_background_size="ngModel" [(ngModel)]="data.login_card_background_size">
                            <option value="">Default Cover</option>
                            <option value="cover">Cover</option>
                            <option value="contain">Contain</option>
                            <option value="100% auto">100% Width</option>
                            <option value="auto 100%">100% Height</option>
                        </select>
                    </div>

                    <div class="mb-3">
                        <label for="login_card_min_height" class="form-label fw-bolder">Login Card Min Height</label>
                        <input type="text" class="form-control" id="login_card_min_height"
                            placeholder="Example: 220px" name="login_card_min_height"
                            #login_card_min_height="ngModel" [(ngModel)]="data.login_card_min_height" />
                    </div>

                    <div class="mb-3">
                        <label for="login_button" class="form-label fw-bolder">Login Button</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'login_button')"
                            [loadImage]="data.login_button" (deleteEvent)="delete($event, 'login_button')"
                            #loginBtn></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label for="register_button" class="form-label fw-bolder">Register Button</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'register_button')"
                            [loadImage]="data.register_button" (deleteEvent)="delete($event, 'register_button')"
                            #registerBtn></app-image-uploader>
                    </div>


                    <div class="mb-3">
                        <label for="deposit_button" class="form-label fw-bolder">Deposit Button</label>
                        <app-checbox [setData]="data" [key]="'hide_landing_deposit_button'" [title]="'Hide Deposit Button'"
                            [value]="true"></app-checbox>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'deposit_button')"
                            [loadImage]="data.deposit_button" (deleteEvent)="delete($event, 'deposit_button')"
                            #depositBtn></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label for="withdraw_button" class="form-label fw-bolder">Withdraw Button</label>
                        <app-checbox [setData]="data" [key]="'hide_landing_withdraw_button'" [title]="'Hide Withdraw Button'"
                            [value]="true"></app-checbox>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'withdraw_button')"
                            [loadImage]="data.withdraw_button" (deleteEvent)="delete($event, 'withdraw_button')"
                            #withdrawBtn></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label for="refresh_button" class="form-label fw-bolder">Refresh Button</label>
                        <app-checbox [setData]="data" [key]="'hide_landing_refresh_button'" [title]="'Hide Refresh Button'"
                            [value]="true"></app-checbox>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'refresh_button')"
                            [loadImage]="data.refresh_button" (deleteEvent)="delete($event, 'refresh_button')"
                            #refreshBtn></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label class="form-label fw-bolder">Player Card Visibility</label>
                        <app-checbox [setData]="data" [key]="'hide_landing_login_register'" [title]="'Hide Login/Register Row'"
                            [value]="true"></app-checbox>
                        <app-checbox [setData]="data" [key]="'hide_landing_login_button'" [title]="'Hide Login Button'"
                            [value]="true"></app-checbox>
                        <app-checbox [setData]="data" [key]="'hide_landing_register_button'" [title]="'Hide Register Button'"
                            [value]="true"></app-checbox>
                        <app-checbox [setData]="data" [key]="'hide_landing_minimum_amounts'" [title]="'Hide Minimum Deposit/Withdraw Text'"
                            [value]="true"></app-checbox>
                        <app-checbox [setData]="data" [key]="'hide_landing_promotion_status'" [title]="'Hide Promotion Status Text'"
                            [value]="true"></app-checbox>
                    </div>


                    <hr />
                    <div class="mb-3">
                        <label for="referral_card" class="form-label fw-bolder">Referral Card Background</label>
                        <app-checbox [setData]="data" [key]="'hide_referral_card'" [title]="'Hide Referral Card Background'"
                            [value]="true"></app-checbox>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'referral_card')"
                            [loadImage]="data.referral_card" (deleteEvent)="delete($event, 'referral_card')"
                            #referralCard></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label for="referral_card_text_color" class="form-label fw-bolder">Referral Card Text
                            Color</label>
                        <input type="text" class="form-control" id="referral_card_text_color"
                            placeholder="Referral Card Text Color" name="referral_card_text_color"
                            #referral_card_text_color="ngModel" [(ngModel)]="data.referral_card_text_color" />
                    </div>

                    <div class="mb-3">
                        <label for="invite_button" class="form-label fw-bolder">Invite Button</label>
                        <app-checbox [setData]="data" [key]="'hide_referral_invite_button'" [title]="'Hide Invite Button'"
                            [value]="true"></app-checbox>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'invite_button')"
                            [loadImage]="data.invite_button" (deleteEvent)="delete($event, 'invite_button')"
                            #invite_button></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label for="downline_button" class="form-label fw-bolder">Downline Button</label>
                        <app-checbox [setData]="data" [key]="'hide_referral_downline_button'" [title]="'Hide Downline Button'"
                            [value]="true"></app-checbox>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'downline_button')"
                            [loadImage]="data.downline_button" (deleteEvent)="delete($event, 'downline_button')"
                            #downline_button></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label for="active_downline_button" class="form-label fw-bolder">Active Downline Button</label>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'active_downline_button')"
                            [loadImage]="data.active_downline_button" (deleteEvent)="delete($event, 'active_downline_button')"
                            #active_downline_button></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label for="copy_button" class="form-label fw-bolder">Copy Button</label>
                        <app-checbox [setData]="data" [key]="'hide_referral_copy_button'" [title]="'Hide Copy Button'"
                            [value]="true"></app-checbox>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'copy_button')"
                            [loadImage]="data.copy_button" (deleteEvent)="delete($event, 'copy_button')"
                            #copy_button></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label for="more_info" class="form-label fw-bolder">More Info Button</label>
                        <app-checbox [setData]="data" [key]="'hide_referral_more_info_button'" [title]="'Hide More Info Button'"
                            [value]="true"></app-checbox>
                        <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'more_info')"
                            [loadImage]="data.more_info" (deleteEvent)="delete($event, 'more_info')"
                            #more_info></app-image-uploader>
                    </div>

                    <div class="mb-3">
                        <label class="form-label fw-bolder">Referral Links Visibility</label>
                        <app-checbox [setData]="data" [key]="'hide_referral_quick_links'" [title]="'Hide All Referral Links'"
                            [value]="true"></app-checbox>
                    </div>

                </div>
                <div class="tab-pane fade" [class.show]="selectedTab === 'live-transaction'" [class.active]="selectedTab === 'live-transaction'" id="live-transaction" role="tabpanel" aria-labelledby="live-transaction-tab">
                    <h3 class="mb-0 mt-3 fw-bolder">Live Transaction</h3>
                    <p class="mb-3">Configure the live transaction table for your website.</p>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="card shadow-sm border-0 mb-4">
                                <div class="card-body">
                                    <h5 class="card-title fw-bolder mb-3">Data Source</h5>
                                    <div class="mb-3">
                                        <select class="form-select" name="live_transaction_source" [(ngModel)]="data.live_transaction_source">
                                            <option value="real_wins">Real Wins (Bets)</option>
                                            <option value="real_trans">Real Deposits & Withdrawals</option>
                                            <option value="mockup">Mockup Data</option>
                                        </select>
                                    </div>

                                    <hr>
                                    <h5 class="card-title fw-bolder mb-3">Images</h5>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Background Image</label>
                                        <app-image-uploader #transactionTableBgImage [type]="'single'"
                                            (uploadEvent)="upload($event, 'transaction_table_background_image')"
                                            [loadImage]="data.transaction_table_background_image"
                                            (deleteEvent)="delete($event, 'transaction_table_background_image')"></app-image-uploader>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Header Icon</label>
                                        <app-image-uploader #transactionTableIcon [type]="'single'"
                                            (uploadEvent)="upload($event, 'transaction_table_icon')"
                                            [loadImage]="data.transaction_table_icon"
                                            (deleteEvent)="delete($event, 'transaction_table_icon')"></app-image-uploader>
                                        <p class="mb-0 hint">Icon next to "LIVE TRANSACTION" text.</p>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Header Background Image</label>
                                        <app-image-uploader #transactionTableHeadImage [type]="'single'"
                                            (uploadEvent)="upload($event, 'transaction_table_head')"
                                            [loadImage]="data.transaction_table_head"
                                            (deleteEvent)="delete($event, 'transaction_table_head')"></app-image-uploader>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Column 1 Header Image <span class="text-muted fw-normal">(Deposit / Win)</span></label>
                                        <app-image-uploader #transactionTableCol1 [type]="'single'"
                                            (uploadEvent)="upload($event, 'live_transaction_table_col1_image', true)"
                                            (deleteEvent)="delete($event, 'live_transaction_table_col1_image')"
                                            [loadImage]="data.live_transaction_table_col1_image">
                                        </app-image-uploader>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Column 2 Header Image <span class="text-muted fw-normal">(Withdraw / Loss)</span></label>
                                        <app-image-uploader #transactionTableCol2 [type]="'single'"
                                            (uploadEvent)="upload($event, 'live_transaction_table_col2_image', true)"
                                            (deleteEvent)="delete($event, 'live_transaction_table_col2_image')"
                                            [loadImage]="data.live_transaction_table_col2_image">
                                        </app-image-uploader>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="card shadow-sm border-0 mb-4">
                                <div class="card-body">
                                    <h5 class="card-title fw-bolder mb-3">Colors</h5>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Background Color</label>
                                        <div class="d-flex gap-2 align-items-center">
                                            <input type="color" class="form-control form-control-color" style="width:60px" name="transaction_table_background_color" [(ngModel)]="data.transaction_table_background_color">
                                            <span class="text-muted small flex-fill">{{ data.transaction_table_background_color || 'Transparent' }}</span>
                                            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="data.transaction_table_background_color = null">Clear</button>
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Text Color</label>
                                        <div class="d-flex gap-2 align-items-center">
                                            <input type="color" class="form-control form-control-color" style="width:60px" name="transaction_table_text_color" [(ngModel)]="data.transaction_table_text_color">
                                            <span class="text-muted small flex-fill">{{ data.transaction_table_text_color || 'Default' }}</span>
                                            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="data.transaction_table_text_color = null">Clear</button>
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Table Cell Background Color</label>
                                        <div class="d-flex gap-2 align-items-center">
                                            <input type="color" class="form-control form-control-color" style="width:60px" name="live_transaction_table_bg_color" [(ngModel)]="data.live_transaction_table_bg_color">
                                            <span class="text-muted small flex-fill">{{ data.live_transaction_table_bg_color || 'Transparent' }}</span>
                                            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="data.live_transaction_table_bg_color = null">Clear</button>
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Table Cell Font Color</label>
                                        <div class="d-flex gap-2 align-items-center">
                                            <input type="color" class="form-control form-control-color" style="width:60px" name="live_transaction_table_font_color" [(ngModel)]="data.live_transaction_table_font_color">
                                            <span class="text-muted small flex-fill">{{ data.live_transaction_table_font_color || 'Default' }}</span>
                                            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="data.live_transaction_table_font_color = null">Clear</button>
                                        </div>
                                    </div>

                                    <hr>
                                    <h5 class="card-title fw-bolder mb-3">Border & Font</h5>

                                    <div class="mb-3">
                                        <app-checbox [setData]="data" [key]="'live_transaction_table_border'" [title]="'Show Table Border'"
                                            [value]="true"></app-checbox>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Border Color</label>
                                        <input type="color" class="form-control form-control-color w-100" name="live_transaction_table_border_color" [(ngModel)]="data.live_transaction_table_border_color">
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Border Size (px)</label>
                                        <input type="number" class="form-control" name="live_transaction_table_border_size" [(ngModel)]="data.live_transaction_table_border_size">
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Font Size (px)</label>
                                        <input type="number" class="form-control" name="live_transaction_table_font_size" [(ngModel)]="data.live_transaction_table_font_size">
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Header Text Size (px)</label>
                                        <input type="number" class="form-control" name="live_transaction_table_header_font_size" [(ngModel)]="data.live_transaction_table_header_font_size">
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Header Text Color</label>
                                        <div class="d-flex gap-2 align-items-center">
                                            <input type="color" class="form-control form-control-color" style="width:60px" name="live_transaction_table_header_font_color" [(ngModel)]="data.live_transaction_table_header_font_color">
                                            <span class="text-muted small flex-fill">{{ data.live_transaction_table_header_font_color || 'Default' }}</span>
                                            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="data.live_transaction_table_header_font_color = null">Clear</button>
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <app-checbox [setData]="data" [key]="'live_transaction_withdraw_show_game'" [title]="'Show Game in Withdraw (Real Win Source)'"
                                            [value]="true"></app-checbox>
                                        <p class="mb-0 hint">If enabled, game names will be displayed for relevant transactions.</p>
                                    </div>

                                    <hr>
                                    <h5 class="card-title fw-bolder mb-3">Glow Shadow</h5>

                                    <div class="mb-3">
                                        <app-checbox [setData]="data" [key]="'live_transaction_shadow_enabled'" [title]="'Enable Glow Shadow Animation'" [value]="true"></app-checbox>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Shadow Color</label>
                                        <div class="d-flex gap-2 align-items-center">
                                            <input type="color" class="form-control form-control-color" style="width:60px" name="live_transaction_shadow_color" [(ngModel)]="data.live_transaction_shadow_color">
                                            <span class="text-muted small flex-fill">{{ data.live_transaction_shadow_color || '#ffffff' }}</span>
                                            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="data.live_transaction_shadow_color = null">Clear</button>
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Shadow Max Size (px)</label>
                                        <input type="number" class="form-control" name="live_transaction_shadow_size" [(ngModel)]="data.live_transaction_shadow_size" placeholder="20">
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Animation Speed (s)</label>
                                        <input type="number" class="form-control" name="live_transaction_shadow_speed" [(ngModel)]="data.live_transaction_shadow_speed" placeholder="2" step="0.5">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-pane fade" [class.show]="selectedTab === 'fortune-fall'" [class.active]="selectedTab === 'fortune-fall'" id="fortune-fall" role="tabpanel" aria-labelledby="fortune-fall-tab">
                    <h3 class="mb-0 mt-3 fw-bolder">Fortune Fall</h3>
                    <p class="mb-3">Items that fall from top of the screen to bottom. Plays once on page load.</p>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="card shadow-sm border-0 mb-4">
                                <div class="card-body">
                                    <h5 class="card-title fw-bolder mb-3">Settings</h5>

                                    <div class="mb-3">
                                        <app-checbox [setData]="data" [key]="'fortune_fall_enabled'" [title]="'Enable Fortune Fall'" [value]="true"></app-checbox>
                                    </div>

                                    <div class="mb-3">
                                        <app-checbox [setData]="data" [key]="'fortune_fall_infinite'" [title]="'Infinite Loop'" [value]="true"></app-checbox>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Number of Items</label>
                                        <input type="number" class="form-control" name="fortune_fall_count" [(ngModel)]="data.fortune_fall_count" placeholder="30">
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Fall Duration (seconds)</label>
                                        <input type="number" class="form-control" name="fortune_fall_duration" [(ngModel)]="data.fortune_fall_duration" placeholder="4" step="0.5">
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Min Size (px)</label>
                                        <input type="number" class="form-control" name="fortune_fall_min_size" [(ngModel)]="data.fortune_fall_min_size" placeholder="30">
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label fw-bolder">Max Size (px)</label>
                                        <input type="number" class="form-control" name="fortune_fall_max_size" [(ngModel)]="data.fortune_fall_max_size" placeholder="60">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="card shadow-sm border-0 mb-4">
                                <div class="card-body">
                                    <h5 class="card-title fw-bolder mb-3">Item Images</h5>
                                    <p class="text-muted small mb-3">Upload images for the falling items (coins, gems, etc). Multiple images will be randomly picked.</p>

                                    <div class="mb-3">
                                        <app-image-uploader #fortuneFallImages [type]="'multiple'"
                                            (uploadEvent)="upload($event, 'fortune_fall_images')"
                                            (deleteEvent)="delete($event, 'fortune_fall_images')"
                                            [loadImage]="data.fortune_fall_images">
                                        </app-image-uploader>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-pane fade" [class.show]="selectedTab === 'footer'" [class.active]="selectedTab === 'footer'" id="footer" role="tabpanel" aria-labelledby="footer-tab">
                    <h3 class="mb-0 mt-3 fw-bolder">Footer</h3>
                    <p class="mb-3">This is the footer button image. You can upload icon images and they will be
                        displayed in the footer.</p>

                    <div class="card border-0 shadow-sm mb-4">
                        <div class="card-body">
                            <label class="form-label fw-bolder">Footer Height 页脚高度</label>
                            <p class="hint mb-2">Set the footer bar height. "Auto" adjusts to content. Default is 60px.</p>
                            <div class="btn-group btn-group-sm w-100" role="group">
                                <button type="button" class="btn" [class.btn-primary]="data.footer_height == 'auto'" [class.btn-outline-secondary]="data.footer_height != 'auto'" (click)="data.footer_height = 'auto'">Auto</button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_height == '40'" [class.btn-outline-secondary]="data.footer_height != '40'" (click)="data.footer_height = '40'">40px</button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_height == '50'" [class.btn-outline-secondary]="data.footer_height != '50'" (click)="data.footer_height = '50'">50px</button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_height == '60' || !data.footer_height" [class.btn-outline-secondary]="data.footer_height != '60' && data.footer_height" (click)="data.footer_height = '60'">60px</button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_height == '70'" [class.btn-outline-secondary]="data.footer_height != '70'" (click)="data.footer_height = '70'">70px</button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_height == '80'" [class.btn-outline-secondary]="data.footer_height != '80'" (click)="data.footer_height = '80'">80px</button>
                            </div>
                        </div>
                    </div>

                    <div class="mb-4">
                        <label class="form-label fw-bolder">Button Order 排列顺序</label>
                        <p class="hint mb-2">Drag to reorder footer buttons. The order here is reflected on the frontend.</p>
                        <div cdkDropList class="d-flex flex-column gap-2" (cdkDropListDropped)="onFooterDrop($event)">
                            <div *ngFor="let key of footerOrder" cdkDrag
                                class="d-flex align-items-center gap-2 p-2 rounded border bg-white" style="cursor:grab">
                                <span cdkDragHandle class="text-muted" style="cursor:grab">&#9776;</span>
                                <span class="fw-bold flex-fill">{{ FOOTER_BUTTON_LABELS[key] }}</span>
                                <span class="text-muted small">{{ key }}</span>
                            </div>
                        </div>
                    </div>
                    <p class="hint mb-3">Each icon has its own size (px). Icons larger than the footer bar overflow upward. Leave blank to use the default (40px).</p>

                    <!-- Home -->
                    <div class="card border-0 shadow-sm mb-3">
                        <div class="card-body">
                            <label class="form-label fw-bolder">Home Button</label>
                            <app-checbox [setData]="data" [key]="'footer_hide_home_button'" [title]="'Hide Home Button'"
                                [value]="true"></app-checbox>
                            <div class="btn-group btn-group-sm w-100 mb-2" role="group">
                                <button type="button" class="btn" [class.btn-primary]="data.footer_home_btn_size == 30" [class.btn-outline-secondary]="data.footer_home_btn_size != 30" (click)="data.footer_home_btn_size = 30">XS <small>30px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_home_btn_size == 40 || !data.footer_home_btn_size" [class.btn-outline-secondary]="data.footer_home_btn_size != 40 && data.footer_home_btn_size" (click)="data.footer_home_btn_size = 40">S <small>40px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_home_btn_size == 50" [class.btn-outline-secondary]="data.footer_home_btn_size != 50" (click)="data.footer_home_btn_size = 50">M <small>50px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_home_btn_size == 60" [class.btn-outline-secondary]="data.footer_home_btn_size != 60" (click)="data.footer_home_btn_size = 60">L <small>60px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_home_btn_size == 75" [class.btn-outline-secondary]="data.footer_home_btn_size != 75" (click)="data.footer_home_btn_size = 75">XL <small>75px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_home_btn_size == 90" [class.btn-outline-secondary]="data.footer_home_btn_size != 90" (click)="data.footer_home_btn_size = 90">XXL <small>90px</small></button>
                            </div>
                            <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'footer_home_button')"
                                [loadImage]="data.footer_home_button" (deleteEvent)="delete($event, 'footer_home_button')"
                                #footer_home_button></app-image-uploader>
                        </div>
                    </div>

                    <!-- History -->
                    <div class="card border-0 shadow-sm mb-3">
                        <div class="card-body">
                            <label class="form-label fw-bolder">History Button</label>
                            <app-checbox [setData]="data" [key]="'footer_hide_history_button'" [title]="'Hide History Button'"
                                [value]="true"></app-checbox>
                            <div class="btn-group btn-group-sm w-100 mb-2" role="group">
                                <button type="button" class="btn" [class.btn-primary]="data.footer_history_btn_size == 30" [class.btn-outline-secondary]="data.footer_history_btn_size != 30" (click)="data.footer_history_btn_size = 30">XS <small>30px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_history_btn_size == 40 || !data.footer_history_btn_size" [class.btn-outline-secondary]="data.footer_history_btn_size != 40 && data.footer_history_btn_size" (click)="data.footer_history_btn_size = 40">S <small>40px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_history_btn_size == 50" [class.btn-outline-secondary]="data.footer_history_btn_size != 50" (click)="data.footer_history_btn_size = 50">M <small>50px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_history_btn_size == 60" [class.btn-outline-secondary]="data.footer_history_btn_size != 60" (click)="data.footer_history_btn_size = 60">L <small>60px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_history_btn_size == 75" [class.btn-outline-secondary]="data.footer_history_btn_size != 75" (click)="data.footer_history_btn_size = 75">XL <small>75px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_history_btn_size == 90" [class.btn-outline-secondary]="data.footer_history_btn_size != 90" (click)="data.footer_history_btn_size = 90">XXL <small>90px</small></button>
                            </div>
                            <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'footer_history_button')"
                                [loadImage]="data.footer_history_button" (deleteEvent)="delete($event, 'footer_history_button')"
                                #footer_history_button></app-image-uploader>
                        </div>
                    </div>

                    <!-- Promo -->
                    <div class="card border-0 shadow-sm mb-3">
                        <div class="card-body">
                            <label class="form-label fw-bolder">Promo Button</label>
                            <app-checbox [setData]="data" [key]="'footer_hide_promo_button'" [title]="'Hide Promo Button'"
                                [value]="true"></app-checbox>
                            <div class="btn-group btn-group-sm w-100 mb-2" role="group">
                                <button type="button" class="btn" [class.btn-primary]="data.footer_promo_btn_size == 30" [class.btn-outline-secondary]="data.footer_promo_btn_size != 30" (click)="data.footer_promo_btn_size = 30">XS <small>30px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_promo_btn_size == 40 || !data.footer_promo_btn_size" [class.btn-outline-secondary]="data.footer_promo_btn_size != 40 && data.footer_promo_btn_size" (click)="data.footer_promo_btn_size = 40">S <small>40px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_promo_btn_size == 50" [class.btn-outline-secondary]="data.footer_promo_btn_size != 50" (click)="data.footer_promo_btn_size = 50">M <small>50px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_promo_btn_size == 60" [class.btn-outline-secondary]="data.footer_promo_btn_size != 60" (click)="data.footer_promo_btn_size = 60">L <small>60px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_promo_btn_size == 75" [class.btn-outline-secondary]="data.footer_promo_btn_size != 75" (click)="data.footer_promo_btn_size = 75">XL <small>75px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_promo_btn_size == 90" [class.btn-outline-secondary]="data.footer_promo_btn_size != 90" (click)="data.footer_promo_btn_size = 90">XXL <small>90px</small></button>
                            </div>
                            <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'footer_promo_button')"
                                [loadImage]="data.footer_promo_button" (deleteEvent)="delete($event, 'footer_promo_button')"
                                #footer_promo_button></app-image-uploader>
                        </div>
                    </div>

                    <!-- Chat -->
                    <div class="card border-0 shadow-sm mb-3">
                        <div class="card-body">
                            <label class="form-label fw-bolder">Chat Button</label>
                            <app-checbox [setData]="data" [key]="'footer_hide_chat_button'" [title]="'Hide Chat Button'"
                                [value]="true"></app-checbox>
                            <div class="btn-group btn-group-sm w-100 mb-2" role="group">
                                <button type="button" class="btn" [class.btn-primary]="data.footer_chat_btn_size == 30" [class.btn-outline-secondary]="data.footer_chat_btn_size != 30" (click)="data.footer_chat_btn_size = 30">XS <small>30px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_chat_btn_size == 40 || !data.footer_chat_btn_size" [class.btn-outline-secondary]="data.footer_chat_btn_size != 40 && data.footer_chat_btn_size" (click)="data.footer_chat_btn_size = 40">S <small>40px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_chat_btn_size == 50" [class.btn-outline-secondary]="data.footer_chat_btn_size != 50" (click)="data.footer_chat_btn_size = 50">M <small>50px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_chat_btn_size == 60" [class.btn-outline-secondary]="data.footer_chat_btn_size != 60" (click)="data.footer_chat_btn_size = 60">L <small>60px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_chat_btn_size == 75" [class.btn-outline-secondary]="data.footer_chat_btn_size != 75" (click)="data.footer_chat_btn_size = 75">XL <small>75px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_chat_btn_size == 90" [class.btn-outline-secondary]="data.footer_chat_btn_size != 90" (click)="data.footer_chat_btn_size = 90">XXL <small>90px</small></button>
                            </div>
                            <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'footer_chat_button')"
                                [loadImage]="data.footer_chat_button" (deleteEvent)="delete($event, 'footer_chat_button')"
                                #footer_chat_button></app-image-uploader>
                        </div>
                    </div>

                    <!-- Setting -->
                    <div class="card border-0 shadow-sm mb-3">
                        <div class="card-body">
                            <label class="form-label fw-bolder">Setting Button</label>
                            <app-checbox [setData]="data" [key]="'footer_hide_setting_button'" [title]="'Hide Setting Button'"
                                [value]="true"></app-checbox>
                            <div class="btn-group btn-group-sm w-100 mb-2" role="group">
                                <button type="button" class="btn" [class.btn-primary]="data.footer_setting_btn_size == 30" [class.btn-outline-secondary]="data.footer_setting_btn_size != 30" (click)="data.footer_setting_btn_size = 30">XS <small>30px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_setting_btn_size == 40 || !data.footer_setting_btn_size" [class.btn-outline-secondary]="data.footer_setting_btn_size != 40 && data.footer_setting_btn_size" (click)="data.footer_setting_btn_size = 40">S <small>40px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_setting_btn_size == 50" [class.btn-outline-secondary]="data.footer_setting_btn_size != 50" (click)="data.footer_setting_btn_size = 50">M <small>50px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_setting_btn_size == 60" [class.btn-outline-secondary]="data.footer_setting_btn_size != 60" (click)="data.footer_setting_btn_size = 60">L <small>60px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_setting_btn_size == 75" [class.btn-outline-secondary]="data.footer_setting_btn_size != 75" (click)="data.footer_setting_btn_size = 75">XL <small>75px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_setting_btn_size == 90" [class.btn-outline-secondary]="data.footer_setting_btn_size != 90" (click)="data.footer_setting_btn_size = 90">XXL <small>90px</small></button>
                            </div>
                            <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'footer_setting_button')"
                                [loadImage]="data.footer_setting_button" (deleteEvent)="delete($event, 'footer_setting_button')"
                                #footer_setting_button></app-image-uploader>
                        </div>
                    </div>

                    <!-- Lucky Draw -->
                    <div class="card border-0 shadow-sm mb-3">
                        <div class="card-body">
                            <label class="form-label fw-bolder">Lucky Draw Button</label>
                            <app-checbox [setData]="data" [key]="'footer_hide_lucky_draw_button'" [title]="'Hide Lucky Draw Button'"
                                [value]="true"></app-checbox>
                            <div class="btn-group btn-group-sm w-100 mb-2" role="group">
                                <button type="button" class="btn" [class.btn-primary]="data.footer_lucky_draw_btn_size == 30" [class.btn-outline-secondary]="data.footer_lucky_draw_btn_size != 30" (click)="data.footer_lucky_draw_btn_size = 30">XS <small>30px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_lucky_draw_btn_size == 40 || !data.footer_lucky_draw_btn_size" [class.btn-outline-secondary]="data.footer_lucky_draw_btn_size != 40 && data.footer_lucky_draw_btn_size" (click)="data.footer_lucky_draw_btn_size = 40">S <small>40px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_lucky_draw_btn_size == 50" [class.btn-outline-secondary]="data.footer_lucky_draw_btn_size != 50" (click)="data.footer_lucky_draw_btn_size = 50">M <small>50px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_lucky_draw_btn_size == 60" [class.btn-outline-secondary]="data.footer_lucky_draw_btn_size != 60" (click)="data.footer_lucky_draw_btn_size = 60">L <small>60px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_lucky_draw_btn_size == 75" [class.btn-outline-secondary]="data.footer_lucky_draw_btn_size != 75" (click)="data.footer_lucky_draw_btn_size = 75">XL <small>75px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_lucky_draw_btn_size == 90" [class.btn-outline-secondary]="data.footer_lucky_draw_btn_size != 90" (click)="data.footer_lucky_draw_btn_size = 90">XXL <small>90px</small></button>
                            </div>
                            <app-checbox [setData]="data" [key]="'footer_enabled_lucky_draw'" [title]="'Show Lucky Draw in Footer'"
                                [value]="true"></app-checbox>
                            <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'footer_lucky_draw_button')"
                                [loadImage]="data.footer_lucky_draw_button" (deleteEvent)="delete($event, 'footer_lucky_draw_button')"
                                #footer_lucky_draw_button></app-image-uploader>
                        </div>
                    </div>

                    <!-- Lucky Draw Image Page -->
                    <div class="card border-0 shadow-sm mb-3">
                        <div class="card-body">
                            <label class="form-label fw-bolder">Lucky Draw Image Page Button</label>
                            <app-checbox [setData]="data" [key]="'footer_hide_lucky_draw_page_button'" [title]="'Hide Lucky Draw Image Page Button'"
                                [value]="true"></app-checbox>
                            <div class="btn-group btn-group-sm w-100 mb-2" role="group">
                                <button type="button" class="btn" [class.btn-primary]="data.footer_lucky_draw_page_btn_size == 30" [class.btn-outline-secondary]="data.footer_lucky_draw_page_btn_size != 30" (click)="data.footer_lucky_draw_page_btn_size = 30">XS <small>30px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_lucky_draw_page_btn_size == 40 || !data.footer_lucky_draw_page_btn_size" [class.btn-outline-secondary]="data.footer_lucky_draw_page_btn_size != 40 && data.footer_lucky_draw_page_btn_size" (click)="data.footer_lucky_draw_page_btn_size = 40">S <small>40px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_lucky_draw_page_btn_size == 50" [class.btn-outline-secondary]="data.footer_lucky_draw_page_btn_size != 50" (click)="data.footer_lucky_draw_page_btn_size = 50">M <small>50px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_lucky_draw_page_btn_size == 60" [class.btn-outline-secondary]="data.footer_lucky_draw_page_btn_size != 60" (click)="data.footer_lucky_draw_page_btn_size = 60">L <small>60px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_lucky_draw_page_btn_size == 75" [class.btn-outline-secondary]="data.footer_lucky_draw_page_btn_size != 75" (click)="data.footer_lucky_draw_page_btn_size = 75">XL <small>75px</small></button>
                                <button type="button" class="btn" [class.btn-primary]="data.footer_lucky_draw_page_btn_size == 90" [class.btn-outline-secondary]="data.footer_lucky_draw_page_btn_size != 90" (click)="data.footer_lucky_draw_page_btn_size = 90">XXL <small>90px</small></button>
                            </div>
                            <app-checbox [setData]="data" [key]="'footer_enabled_lucky_draw_page'" [title]="'Show Lucky Draw Image Page in Footer'"
                                [value]="true"></app-checbox>
                            <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'footer_lucky_draw_page_button')"
                                [loadImage]="data.footer_lucky_draw_page_button" (deleteEvent)="delete($event, 'footer_lucky_draw_page_button')"
                                #footer_lucky_draw_page_button></app-image-uploader>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" [class.show]="selectedTab === 'withdrawdeposit'" [class.active]="selectedTab === 'withdrawdeposit'" id="withdrawdeposit" role="tabpanel" aria-labelledby="withdrawdeposit-tab">
                    <h3 class="mb-0 mt-3 fw-bolder">Withdraw & Deposit</h3>
                    <p class="mb-3 hint">Configure deposit and withdrawal behaviour, appearance, and link visibility.</p>

                    <div class="card mb-3">
                        <div class="card-header fw-bolder">Free Credit After Withdraw / Lost All</div>
                        <div class="card-body">
                            <div class="mb-3">
                                <app-checbox [setData]="data" [key]="'enable_free_credit_after_withdraw_or_lost_all'"
                                    [title]="'Enable Free Credit After Withdraw / Lost All'" [value]="true"></app-checbox>
                                <p class="mb-0 hint">When enabled, the system auto-joins the selected free-credit promotion after a withdrawal. The same rule is also checked when the free-credit flow detects lost-all state.</p>
                            </div>
                            <div class="row">
                                <div class="col-md-4 col-12">
                                    <div class="mb-3">
                                        <label for="free_credit_promotion_id" class="form-label fw-bolder">Free Credit Promotion ID</label>
                                        <input type="number" class="form-control" id="free_credit_promotion_id"
                                            placeholder="Promotion ID" name="free_credit_promotion_id"
                                            #free_credit_promotion_id="ngModel" [(ngModel)]="data.free_credit_promotion_id" />
                                        <p class="mb-0 hint">Use an active promotion with type Free Credit. The selected promotion controls title, games, and display text.</p>
                                    </div>
                                </div>
                                <div class="col-md-4 col-12">
                                    <div class="mb-3">
                                        <label for="free_credit_turnover_multiplier" class="form-label fw-bolder">Turnover Multiplier</label>
                                        <input type="number" class="form-control" id="free_credit_turnover_multiplier"
                                            placeholder="5" name="free_credit_turnover_multiplier"
                                            #free_credit_turnover_multiplier="ngModel" [(ngModel)]="data.free_credit_turnover_multiplier" />
                                        <p class="mb-0 hint">Required turnover = free credit amount x multiplier. Default is 5.</p>
                                    </div>
                                </div>
                                <div class="col-md-4 col-12">
                                    <div class="mb-3">
                                        <label for="free_credit_allowed_game_limit" class="form-label fw-bolder">Allowed Game Limit</label>
                                        <input type="number" class="form-control" id="free_credit_allowed_game_limit"
                                            placeholder="2" name="free_credit_allowed_game_limit"
                                            #free_credit_allowed_game_limit="ngModel" [(ngModel)]="data.free_credit_allowed_game_limit" />
                                        <p class="mb-0 hint">Maximum games allowed on that free-credit promotion. Default is 2.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ── DEPOSIT ─────────────────────────────────────────── -->
                    <div class="card mb-3">
                        <div class="card-header fw-bolder">Deposit Settings</div>
                        <div class="card-body">
                            <div class="mb-3">
                                <label for="minimum_deposit" class="form-label fw-bolder">Minimum Deposit</label>
                                <input type="text" class="form-control" id="minimum_deposit" placeholder="Minimum Deposit"
                                    name="minimum_deposit" #minimum_deposit="ngModel" [(ngModel)]="data.minimum_deposit" />
                                <p class="mb-0 hint">Minimum deposit amount the user can deposit. Supports decimal numbers.</p>
                            </div>
                            <div class="mb-3">
                                <label for="deposit_predefined_buttons" class="form-label fw-bolder">Predefined Deposit Buttons</label>
                                <input type="text" class="form-control" id="deposit_predefined_buttons"
                                    placeholder="e.g. 10,20,50,100,200,500" name="deposit_predefined_buttons"
                                    #deposit_predefined_buttons="ngModel" [(ngModel)]="data.deposit_predefined_buttons" />
                                <p class="mb-0 hint">Comma-separated quick-select amounts shown on the deposit page. Example: 10,20,50,100,200,500</p>
                            </div>
                            <div class="mb-3">
                                <app-checbox [key]="'disabled_deposit_slip_upload'" [title]="'Disable Deposit Slip Upload'"
                                    [setData]="data" [value]="true"></app-checbox>
                                <p class="mb-0 hint">If enabled, players cannot upload a deposit slip.</p>
                            </div>
                            <div class="mb-3">
                                <label for="deposit_note" class="form-label fw-bolder">Deposit Note</label>
                                <quill-editor [format]="'html'" [(ngModel)]="data.deposit_note" [required]="true"
                                    [styles]="{minHeight: '250px'}"
                                    (onEditorCreated)="editorCreated($event, 'deposit_note')"></quill-editor>
                                <p class="mb-0 hint">Note displayed to the user on the deposit page.</p>
                            </div>
                            <div class="mb-3">
                                <label for="deposit_image" class="form-label fw-bolder">Deposit Image</label>
                                <app-image-uploader [type]="'multiple'" (uploadEvent)="upload($event, 'deposit_image')"
                                    (deleteEvent)="delete($event, 'deposit_image')" #depositImage></app-image-uploader>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header fw-bolder">Deposit Appearance</div>
                        <div class="card-body">
                            <div class="mb-3">
                                <label for="deposit_title_color" class="form-label fw-bolder">Title Color</label>
                                <input type="text" class="form-control" id="deposit_title_color"
                                    placeholder="e.g. #000000" name="deposit_title_color" #deposit_title_color="ngModel"
                                    [(ngModel)]="data.deposit_title_color" />
                                <p class="mb-0 hint">Title color on the deposit page. Example: #000000 / rgb(0,0,0) / rgba(0,0,0,0.5)</p>
                            </div>
                            <div class="mb-3">
                                <label for="deposit_note_text_color" class="form-label fw-bolder">Note Text Color</label>
                                <input type="text" class="form-control" id="deposit_note_text_color"
                                    placeholder="e.g. #000000" name="deposit_note_text_color"
                                    #deposit_note_text_color="ngModel" [(ngModel)]="data.deposit_note_text_color" />
                                <p class="mb-0 hint">Text color of the deposit note.</p>
                            </div>
                            <div class="mb-3">
                                <label for="deposit_note_background_color" class="form-label fw-bolder">Note Background Color</label>
                                <input type="text" class="form-control" id="deposit_note_background_color"
                                    placeholder="e.g. #000000" name="deposit_note_background_color"
                                    #deposit_note_background_color="ngModel" [(ngModel)]="data.deposit_note_background_color" />
                                <p class="mb-0 hint">Background color of the deposit note.</p>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header fw-bolder">Deposit — Hide Links</div>
                        <div class="card-body">
                            <div class="mb-3">
                                <app-checbox [setData]="data" [key]="'deposit_hide_platform_chat'"
                                    [title]="'Hide platform chat link'" [value]="true"></app-checbox>
                                <p class="mb-0 hint">Hides the platform chat link on the deposit page.</p>
                            </div>
                            <div class="mb-3">
                                <app-checbox [setData]="data" [key]="'deposit_hide_whatsapp_link'"
                                    [title]="'Hide WhatsApp link'" [value]="true"></app-checbox>
                                <p class="mb-0 hint">Hides the WhatsApp link on the deposit page.</p>
                            </div>
                            <div class="mb-3">
                                <app-checbox [setData]="data" [key]="'deposit_hide_telegram_link'"
                                    [title]="'Hide Telegram link'" [value]="true"></app-checbox>
                                <p class="mb-0 hint">Hides the Telegram link on the deposit page.</p>
                            </div>
                            <div class="mb-0">
                                <app-checbox [setData]="data" [key]="'deposit_hide_facebook_link'"
                                    [title]="'Hide Facebook link'" [value]="true"></app-checbox>
                                <p class="mb-0 hint">Hides the Facebook link on the deposit page.</p>
                            </div>
                        </div>
                    </div>

                    <!-- ── WITHDRAW ────────────────────────────────────────── -->
                    <div class="card mb-3">
                        <div class="card-header fw-bolder">Withdraw Settings</div>
                        <div class="card-body">
                            <div class="mb-3">
                                <label for="minimum_withdraw" class="form-label fw-bolder">Minimum Withdraw</label>
                                <input type="text" class="form-control" id="minimum_withdraw" placeholder="Minimum Withdraw"
                                    name="minimum_withdraw" #minimum_withdraw="ngModel" [(ngModel)]="data.minimum_withdraw" />
                                <p class="mb-0 hint">Minimum withdrawal amount the user can withdraw. Supports decimal numbers.</p>
                            </div>
                            <div class="mb-3">
                                <app-checbox [setData]="data" [key]="'withdraw_full_balance_only'"
                                    [title]="'Require Full Wallet Withdrawal'" [value]="true"></app-checbox>
                                <p class="mb-0 hint">When enabled, a player can withdraw only their complete wallet balance. Partial withdrawals are rejected.</p>
                            </div>
                            <div class="mb-3">
                                <app-checbox [setData]="data" [key]="'base_turnover_enabled'"
                                    [title]="'Base Deposit Turnover'" [value]="true"></app-checbox>
                                <p class="mb-0 hint">If enabled, players must complete a turnover requirement based on their deposit before withdrawing (only applies when no active promotion).</p>
                            </div>
                            <div class="mb-3" *ngIf="data.base_turnover_enabled">
                                <label for="base_turnover_multiplier" class="form-label fw-bolder">Turnover Multiplier</label>
                                <input type="number" class="form-control" id="base_turnover_multiplier" placeholder="e.g. 1"
                                    name="base_turnover_multiplier" #base_turnover_multiplier="ngModel"
                                    [(ngModel)]="data.base_turnover_multiplier" min="0.1" step="0.1" />
                                <p class="mb-0 hint">Multiplier applied to total deposits since last withdrawal. Example: 1 means player must bet 1× their deposit amount before withdrawing.</p>
                            </div>
                            <div class="mb-3">
                                <label for="withdraw_note" class="form-label fw-bolder">Withdraw Note</label>
                                <quill-editor [format]="'html'" [(ngModel)]="data.withdraw_note" [required]="true"
                                    [styles]="{minHeight: '250px'}"
                                    (onEditorCreated)="editorCreated($event, 'withdraw_note')"></quill-editor>
                                <p class="mb-0 hint">Note displayed to the user on the withdraw page.</p>
                            </div>
                            <div class="mb-3">
                                <label for="withdraw_whatsapp_link" class="form-label fw-bolder">WhatsApp Link</label>
                                <input type="text" class="form-control" id="withdraw_whatsapp_link"
                                    placeholder="e.g. https://wa.me/1234567890" name="withdraw_whatsapp_link"
                                    #withdraw_whatsapp_link="ngModel" [(ngModel)]="data.withdraw_whatsapp_link" />
                                <p class="mb-0 hint">WhatsApp link shown on the withdraw page.</p>
                            </div>
                            <div class="mb-3">
                                <label for="withdraw_whatsapp_image" class="form-label fw-bolder">WhatsApp Image</label>
                                <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'withdraw_whatsapp_image')"
                                    (deleteEvent)="delete($event, 'withdraw_whatsapp_image')"
                                    #withdrawWhatsappImage></app-image-uploader>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header fw-bolder">Withdraw Appearance</div>
                        <div class="card-body">
                            <div class="mb-3">
                                <label for="withdraw_title_color" class="form-label fw-bolder">Title Color</label>
                                <input type="text" class="form-control" id="withdraw_title_color"
                                    placeholder="e.g. #000000" name="withdraw_title_color"
                                    #withdraw_title_color="ngModel" [(ngModel)]="data.withdraw_title_color" />
                                <p class="mb-0 hint">Title color on the withdraw page.</p>
                            </div>
                            <div class="mb-3">
                                <label for="withdraw_note_text_color" class="form-label fw-bolder">Note Text Color</label>
                                <input type="text" class="form-control" id="withdraw_note_text_color"
                                    placeholder="e.g. #000000" name="withdraw_note_text_color"
                                    #withdraw_note_text_color="ngModel" [(ngModel)]="data.withdraw_note_text_color" />
                                <p class="mb-0 hint">Text color of the withdraw note.</p>
                            </div>
                            <div class="mb-3">
                                <label for="withdraw_note_background_color" class="form-label fw-bolder">Note Background Color</label>
                                <input type="text" class="form-control" id="withdraw_note_background_color"
                                    placeholder="e.g. #000000" name="withdraw_note_background_color"
                                    #withdraw_note_background_color="ngModel"
                                    [(ngModel)]="data.withdraw_note_background_color" />
                                <p class="mb-0 hint">Background color of the withdraw note.</p>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header fw-bolder">Withdraw — Hide Links</div>
                        <div class="card-body">
                            <div class="mb-3">
                                <app-checbox [setData]="data" [key]="'withdraw_hide_platform_chat'"
                                    [title]="'Hide platform chat link'" [value]="true"></app-checbox>
                                <p class="mb-0 hint">Hides the platform chat link on the withdraw page.</p>
                            </div>
                            <div class="mb-3">
                                <app-checbox [setData]="data" [key]="'withdraw_hide_whatsapp_link'"
                                    [title]="'Hide WhatsApp link'" [value]="true"></app-checbox>
                                <p class="mb-0 hint">Hides the WhatsApp link on the withdraw page.</p>
                            </div>
                            <div class="mb-3">
                                <app-checbox [setData]="data" [key]="'withdraw_hide_telegram_link'"
                                    [title]="'Hide Telegram link'" [value]="true"></app-checbox>
                                <p class="mb-0 hint">Hides the Telegram link on the withdraw page.</p>
                            </div>
                            <div class="mb-0">
                                <app-checbox [setData]="data" [key]="'withdraw_hide_facebook_link'"
                                    [title]="'Hide Facebook link'" [value]="true"></app-checbox>
                                <p class="mb-0 hint">Hides the Facebook link on the withdraw page.</p>
                            </div>
                        </div>
                    </div>

                    <!-- ── PROMOTION ───────────────────────────────────────── -->
                    <div class="card mb-3">
                        <div class="card-header fw-bolder">Promotion Settings</div>
                        <div class="card-body">
                            <div class="mb-3">
                                <label for="promotion_topup_ratio" class="form-label fw-bolder">Promotion Topup Ratio</label>
                                <select name="promotion_topup_ratio" #promotion_topup_ratio="ngModel"
                                    [(ngModel)]="data.promotion_topup_ratio" class="form-control">
                                    <option value="0.01">1%</option>
                                    <option value="0.02">2%</option>
                                    <option value="0.03">3%</option>
                                    <option value="0.04">4%</option>
                                    <option value="0.05">5%</option>
                                    <option value="0.06">6%</option>
                                    <option value="0.07">7%</option>
                                    <option value="0.08">8%</option>
                                    <option value="0.09">9%</option>
                                    <option value="0.1">10%</option>
                                    <option value="0.11">11%</option>
                                    <option value="0.12">12%</option>
                                    <option value="0.13">13%</option>
                                    <option value="0.14">14%</option>
                                    <option value="0.15">15%</option>
                                    <option value="0.16">16%</option>
                                    <option value="0.17">17%</option>
                                    <option value="0.18">18%</option>
                                    <option value="0.19">19%</option>
                                    <option value="0.2">20%</option>
                                    <option value="0.21">21%</option>
                                    <option value="0.22">22%</option>
                                    <option value="0.23">23%</option>
                                    <option value="0.24">24%</option>
                                    <option value="0.25">25%</option>
                                    <option value="0.26">26%</option>
                                    <option value="0.27">27%</option>
                                    <option value="0.28">28%</option>
                                    <option value="0.29">29%</option>
                                    <option value="0.3">30%</option>
                                    <option value="0.31">31%</option>
                                    <option value="0.32">32%</option>
                                    <option value="0.33">33%</option>
                                    <option value="0.34">34%</option>
                                    <option value="0.35">35%</option>
                                    <option value="0.36">36%</option>
                                    <option value="0.37">37%</option>
                                    <option value="0.38">38%</option>
                                    <option value="0.39">39%</option>
                                    <option value="0.4">40%</option>
                                    <option value="0.41">41%</option>
                                    <option value="0.42">42%</option>
                                    <option value="0.43">43%</option>
                                    <option value="0.44">44%</option>
                                    <option value="0.45">45%</option>
                                    <option value="0.46">46%</option>
                                    <option value="0.47">47%</option>
                                    <option value="0.48">48%</option>
                                    <option value="0.49">49%</option>
                                    <option value="0.5">50%</option>
                                    <option value="0.51">51%</option>
                                    <option value="0.52">52%</option>
                                    <option value="0.53">53%</option>
                                    <option value="0.54">54%</option>
                                    <option value="0.55">55%</option>
                                    <option value="0.56">56%</option>
                                    <option value="0.57">57%</option>
                                    <option value="0.58">58%</option>
                                    <option value="0.59">59%</option>
                                    <option value="0.6">60%</option>
                                    <option value="0.61">61%</option>
                                    <option value="0.62">62%</option>
                                    <option value="0.63">63%</option>
                                    <option value="0.64">64%</option>
                                    <option value="0.65">65%</option>
                                    <option value="0.66">66%</option>
                                    <option value="0.67">67%</option>
                                    <option value="0.68">68%</option>
                                    <option value="0.69">69%</option>
                                    <option value="0.7">70%</option>
                                    <option value="0.71">71%</option>
                                    <option value="0.72">72%</option>
                                    <option value="0.73">73%</option>
                                    <option value="0.74">74%</option>
                                    <option value="0.75">75%</option>
                                    <option value="0.76">76%</option>
                                    <option value="0.77">77%</option>
                                    <option value="0.78">78%</option>
                                    <option value="0.79">79%</option>
                                    <option value="0.8">80%</option>
                                    <option value="0.81">81%</option>
                                    <option value="0.82">82%</option>
                                    <option value="0.83">83%</option>
                                    <option value="0.84">84%</option>
                                    <option value="0.85">85%</option>
                                    <option value="0.86">86%</option>
                                    <option value="0.87">87%</option>
                                    <option value="0.88">88%</option>
                                    <option value="0.89">89%</option>
                                    <option value="0.9">90%</option>
                                    <option value="0.91">91%</option>
                                    <option value="0.92">92%</option>
                                    <option value="0.93">93%</option>
                                    <option value="0.94">94%</option>
                                    <option value="0.95">95%</option>
                                    <option value="0.96">96%</option>
                                    <option value="0.97">97%</option>
                                    <option value="0.98">98%</option>
                                    <option value="0.99">99%</option>
                                    <option value="1">100%</option>
                                </select>
                                <p class="mb-0 hint">When a player in an active promotion tops up and the wallet balance falls below this ratio, the wallet balance will be forfeited.</p>
                            </div>
                            <div class="mb-3">
                                <app-checbox [setData]="data" [key]="'forfit_wallet_balance_when_balance_is_fall_below'"
                                    [title]="'Forfeit wallet balance when balance falls below threshold'" [value]="true"></app-checbox>
                                <p class="mb-0 hint">If enabled, the wallet balance will be forfeited when it falls below the minimum deposit amount.</p>
                            </div>
                            <div class="mb-0" *ngIf="data.forfit_wallet_balance_when_balance_is_fall_below">
                                <label for="forfit_wallet_balance_fall_below_percentage" class="form-label fw-bolder">Fall-below Threshold % (0–100)</label>
                                <input type="text" class="form-control" id="forfit_wallet_balance_fall_below_percentage"
                                    placeholder="Fall below % (0-100)" name="forfit_wallet_balance_fall_below_percentage"
                                    #forfit_wallet_balance_fall_below_percentage="ngModel"
                                    [(ngModel)]="data.forfit_wallet_balance_fall_below_percentage" />
                                <p class="mb-0 hint">Percentage of the wallet balance to forfeit when it falls below the promotion bonus + pre-promotion wallet amount.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" [class.show]="selectedTab === 'agent'" [class.active]="selectedTab === 'agent'" id="agent" role="tabpanel" aria-labelledby="agent-tab">
                    <h3 class="mb-0 mt-3 fw-bolder">Agent</h3>
                    <p class="mb-3">This is the agent information of the website. You can change the agent settings.</p>

                    <div class="card border-0 shadow-sm mb-4">
                        <div class="card-body">
                            <h5 class="card-title fw-bolder mb-1">Referral Wallet Transfer</h5>
                            <p class="mb-3 hint">Configure self-service transfers from a player's referral wallet to their main wallet.</p>

                            <div class="mb-3">
                                <label for="referral_transfer_enabled" class="form-label fw-bolder">Enable Self-Service Transfer</label>
                                <select class="form-select" id="referral_transfer_enabled" name="referral_transfer_enabled"
                                    [(ngModel)]="data.referral_transfer_enabled">
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                                <p class="mb-0 hint">Shows the player-facing “Transfer to Wallet” option. The admin override is always available to permitted admins.</p>
                            </div>

                            <div class="mb-3">
                                <label for="referral_transfer_multiplier" class="form-label fw-bolder">Wager Multiplier</label>
                                <input type="number" step="0.01" min="0" class="form-control"
                                    id="referral_transfer_multiplier" name="referral_transfer_multiplier" placeholder="1"
                                    [(ngModel)]="data.referral_transfer_multiplier" />
                                <p class="mb-0 hint">Required turnover equals transfer amount × multiplier. Blank or non-positive values default to 1.</p>
                            </div>

                            <div class="mb-3">
                                <label for="referral_transfer_min" class="form-label fw-bolder">Minimum Transfer Amount</label>
                                <input type="number" step="0.01" min="0" class="form-control"
                                    id="referral_transfer_min" name="referral_transfer_min" placeholder="1"
                                    [(ngModel)]="data.referral_transfer_min" />
                                <p class="mb-0 hint">Blank or non-positive values default to 1.</p>
                            </div>

                            <div class="mb-0">
                                <label for="referral_transfer_wager_required" class="form-label fw-bolder">Require Wager</label>
                                <select class="form-select" id="referral_transfer_wager_required" name="referral_transfer_wager_required"
                                    [(ngModel)]="data.referral_transfer_wager_required">
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                                <p class="mb-0 hint">When disabled, players can transfer without meeting the wager gate. Admin override always bypasses it.</p>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="agent_account_period" class="form-label fw-bolder">Agent Account Period</label>
                        <select class="form-control" id="agent_account_period" name="agent_account_period"
                                [(ngModel)]="data.agent_account_period" #agent_account_period="ngModel">
                            <option value="current_week">Current Week (Mon – today)</option>
                            <option value="last_week">Last Week (Mon – Sun)</option>
                            <option value="current_month">Current Month (1st – today)</option>
                            <option value="last_month">Last Month</option>
                        </select>
                        <p class="mb-0 hint">
                            Controls the period shown on the agent's own account page and on the panel Agent Account view.
                            Default is "Current Month" to match existing behavior.
                        </p>
                    </div>
                    <hr />

                    <div class="mb-3">
                        <label for="agent_commission_override" class="form-label fw-bolder">Allowed Agent Overriding on
                            Player Win's Bet</label>
                        <select class="form-select" id="agent_commission_override" name="agent_commission_override"
                            #agent_commission_override="ngModel" [(ngModel)]="data.agent_commission_override">
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>

                        <p class="mb-0 hint">If this is enabled, the agent can override the commission on player win's
                            bet. Agent need to set the overriding rate in player list page.</p>
                    </div>
                    <hr />
                    <div class="mb-3">
                        <label for="agent_total_commission_rate" class="form-label fw-bolder">Total Commission Rate</label>
                        <div class="input-group mb-2">
                            <input type="number" step="0.001" min="0" max="1" class="form-control"
                                id="agent_total_commission_rate" placeholder="0.01"
                                name="agent_total_commission_rate" #agent_total_commission_rate="ngModel"
                                [(ngModel)]="data.agent_total_commission_rate" />
                        </div>
                        <p class="mb-0 hint">Used by non-game rolling formulas. Game-based rolling uses each game's configured rate directly.</p>
                    </div>

	                    <div class="mb-3">
	                        <label for="agent_company_bucket_rate" class="form-label fw-bolder">Company Bucket Rate</label>
	                        <div class="input-group mb-2">
	                            <input type="number" step="0.01" min="0" max="1" class="form-control"
	                                id="agent_company_bucket_rate" placeholder="0.3"
                                name="agent_company_bucket_rate" #agent_company_bucket_rate="ngModel"
                                [(ngModel)]="data.agent_company_bucket_rate" />
                        </div>
	                        <p class="mb-0 hint">Portion of the total commission pool retained by the company (e.g. 0.3 = 30% of the total pool goes to company bucket).</p>
	                    </div>

	                    <div class="mb-3">
	                        <app-checbox [setData]="data" [key]="'agent_game_based_rolling_enabled'"
	                            [title]="'Use Game-Based Member Rolling'" [value]="true"></app-checbox>
	                        <p class="mb-0 hint">When enabled, rolling uses settled game profit by provider/category: rolling * game rate * member pool * tier. The company bucket uses rolling * game rate * bucket rate.</p>
	                    </div>

	                    <p class="mb-0 hint">If game-based rolling is disabled, set Level 1/2/3 Member Rolling Rate in Player Level Management. Those member level values are used for rolling payout.</p>

                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'agent_red_share_mode'"
                            [title]="'Red Share Mode (红股差额)'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">
                            When enabled, agent commission is <code>adjusted_win &times; agent_rate%</code> and each
                            upline automatically earns the rate spread (e.g. L1 at 50% earns 5% from L2 at 45%).
                            Set each agent's <strong>Agent Rate</strong> as a whole number percentage (e.g. 50 = 50%).
                            Rolling Deduction Rate defaults to 1.0 (full deduction) and bonus is not deducted in this mode.
                            Do <strong>not</strong> set Agent Commission Formula when this mode is on.
                            This overrides game-based and level-based rolling.
                        </p>
                    </div>

                    <!-- Red Share Mode tunables (only used when Red Share Mode is enabled) -->
                    <div class="mb-3">
                        <label for="agent_red_share_rolling_rate" class="form-label fw-bolder">Red Share — Commission (CM) Deduction Rate</label>
                        <div class="input-group mb-2">
                            <input type="number" step="0.01" min="0" max="1" class="form-control"
                                id="agent_red_share_rolling_rate" placeholder="1.0"
                                name="agent_red_share_rolling_rate" #agent_red_share_rolling_rate="ngModel"
                                [(ngModel)]="data.agent_red_share_rolling_rate" />
                        </div>
                        <p class="mb-0 hint">Portion of the already-paid per-bet commission (自己和公司 + 上线 cm) excluded from profit <strong>before</strong> applying the share rate. Default 1.0 = full exclusion (matches the 红股 spec: 6.84 sell − 0.034 cm = 6.806, ×50%). Leave blank for 1.0.</p>
                    </div>

                    <div class="mb-3">
                        <label for="agent_red_share_bonus_rate" class="form-label fw-bolder">Red Share — Bonus Deduction Rate</label>
                        <div class="input-group mb-2">
                            <input type="number" step="0.01" min="0" max="1" class="form-control"
                                id="agent_red_share_bonus_rate" placeholder="0"
                                name="agent_red_share_bonus_rate" #agent_red_share_bonus_rate="ngModel"
                                [(ngModel)]="data.agent_red_share_bonus_rate" />
                        </div>
                        <p class="mb-0 hint">Portion of bonus excluded from profit before applying the share rate. Default 0 = bonus not deducted in red share mode. Leave blank for 0.</p>
                    </div>

                    <div class="mb-3">
                        <label for="agent_red_share_include_own_deposit" class="form-label fw-bolder">Red Share — Include Agent's Own Betting</label>
                        <select class="form-select" id="agent_red_share_include_own_deposit"
                            name="agent_red_share_include_own_deposit" #agent_red_share_include_own_deposit="ngModel"
                            [(ngModel)]="data.agent_red_share_include_own_deposit">
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                        <p class="mb-0 hint">When Yes, the agent's own bets count toward their subtree profit (the 红股 worked example includes the agent's own 100-credit bet). Default Yes.</p>
                    </div>
                    <hr />

                    <div class="mb-3">
                        <label for="agent_formula" class="form-label fw-bolder">Agent Commission Formula</label>
                        <div class="input-group mb-2">
                            <input type="text" class="form-control" id="agent_formula" placeholder="Enter formula"
                                name="agent_formula" #agent_formula="ngModel" [(ngModel)]="data.agent_formula" />
                        </div>
                        <p class="mb-0 hint">Define the formula for calculating agent commissions.</p>
                    </div>

                    <div class="mb-3">
                        <label for="agent_rolling_deduction_rate" class="form-label fw-bolder">Rolling Deduction Rate</label>
                        <div class="input-group mb-2">
                            <input type="number" step="0.01" min="0" max="1" class="form-control"
                                id="agent_rolling_deduction_rate" placeholder="0.2"
                                name="agent_rolling_deduction_rate" #agent_rolling_deduction_rate="ngModel"
                                [(ngModel)]="data.agent_rolling_deduction_rate" />
                        </div>
                        <p class="mb-0 hint">Rate applied to rolling paid amount when computing daily profit (default: 0.2 = 20%).</p>
                    </div>

                    <div class="mb-3">
                        <label for="agent_bonus_deduction_rate" class="form-label fw-bolder">Bonus Deduction Rate</label>
                        <div class="input-group mb-2">
                            <input type="number" step="0.01" min="0" max="1" class="form-control"
                                id="agent_bonus_deduction_rate" placeholder="0.2"
                                name="agent_bonus_deduction_rate" #agent_bonus_deduction_rate="ngModel"
                                [(ngModel)]="data.agent_bonus_deduction_rate" />
                        </div>
                        <p class="mb-0 hint">Rate applied to bonus amount when computing daily profit (default: 0.2 = 20%).</p>
                    </div>
                    <div class="mb-3">
                        <app-checbox [setData]="data" [key]="'agent_commission_include_own_deposit'"
                            [title]="'Include Agent\'s Own Deposit in Commission'" [value]="true"></app-checbox>
                        <p class="mb-0 hint">When enabled, the agent's own deposits and withdrawals are counted toward their commission calculation, in addition to their downline's activity.</p>
                    </div>
                    <hr />

                    <div class="mb-3">
                        <label class="form-label fw-bolder">Available Variables</label>
                        <ul class="list-group">
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span><code>{{'{balance_adebit_mcredit_mbonus}'}}</code> - Balance lose of the agent +
                                    today debit - today credit - today bonus</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span><code>{{'{total_deposit}'}}</code> - Total daily deposit by downline of the
                                    agent</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span><code>{{'{total_withdraw}'}}</code> - Total daily withdraw by downline of the
                                    agent</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span><code>{{'{total_bonus}'}}</code> - Total daily bonus by downline of the
                                    agent</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span><code>{{'{commission_expense}'}}</code> - Total daily commission expenses</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span><code>{{'{agent_rate}'}}</code> - Legacy formula agent rate. Level-based rolling uses Player Level Management rates.</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span><code>{{'{agent_total_commission_rate}'}}</code> - Total Commission Rate (from setting above)</span>
                            </li>
                        </ul>

                        <p class="mb-0 mt-2 hint">These variables can be used in your commission formula.</p>
                    </div>

                </div>

            </div>
            <div class="col-auto">
                <button type="submit" class="btn btn-primary mb-3 w-100" [disabled]="loading">Update</button>
            </div>
        </form>
    </div>
</div>
